<script>
import lazyLoadComponent from '@router/lazyload-component'
import cloneDeep from 'lodash/cloneDeep'
import { genderFilter, bookingStatusFilter, orderPaymentMethodFilter, paymentStatusMapFilter, taxTypeMap, carrierTypeMap, orderPaymentMethodMap } from '@utils/filter-value-to-text'
import formatDate, { formatGetTime } from '@utils/format-date'
import { formatStatusMessage } from '@utils/request'
import BaseButtonDialog from '@components/BaseButtonDialog'
import { calcTotal, calcBasePrice } from '@utils/order-form'
import { Clipboard } from '@capacitor/clipboard'
import { membreLevelValidityTime } from '@utils/memberLevel'
import scrollToElement from '@utils/scroll-to-element'
import reserveOrder from '@src/mixins/reserveOrder'
import memberLevelDiscountMixin from '@src/mixins/memberLevelDiscountMixin'
import { saveState } from '@utils/browser-help'
import orderDetailMixin from '@src/mixins/orderDetailMixin'
import helperMixin from '@src/mixins/helperMixin'
import { mapActions } from 'vuex'
import Terms from './components/Terms.vue'
import SignPad from './components/SignPad.vue'
import PrintSalonContract from './components/PrintSalonContract.vue'
import { formatContract } from '@utils/PrintFormatter'
const paramsItem = () => {
  return {
    type: 'cosmetic',
    title: '',
    priceId: '',
    price: 0,
    qty: 1,
  }
}

const initData = () => {
  return {
    params: [paramsItem()],
    fullName: '',
    gender: 'male',
    phoneCode: '+886',
    phoneNumber: '',
    phone: '',
    // bankType:'',
    email: '',
    note: '',
    status: 2,
    paymentStatus: 'UNPAID',
    basePrice: '',
    total: '',
    allowExpired: 0,
    coupon: undefined,
    couponCode: '',
    memberId: '',
    prepaidOrderUuid: '',
    byOrderExtrafields: {},
    customerInfos: [],
    // paymentMethod: 'Prepaid',
    paymentMethod: '',
    productId: '',
    bankType: '',
    address: '',
    petId: '',
    city: '',
    district: '',
    errorHandle: false,
    type: 'cosmetic',

    // 假資料先暫做
    storeCredit: '',
    credit: '',
  }
}

const initChildrenData = () => {
  return {
    groupSize: 1,
    startDate: '',
    scheduleItemId: '',
    parentId: '',
    params: [],
    fullName: '',
    gender: 'male',
    phoneCode: '+886',
    phoneNumber: '',
    phone: '',
    email: '',
    note: '',
    status: 2,
    paymentStatus: 'UNPAID',
    basePrice: '',
    total: '',
    memberId: '',
    paymentMethod: '',
    productId: '',
    bankType: '',
    petId: '',
    type: 'cosmetic',
  }
}

export default {
  components: {
    BaseButtonDialog,
    Terms,
    SignPad,
    PrintSalonContract,
    formatContract,
    BaseCollapse: () => lazyLoadComponent(import('@components/BaseCollapse')),
    BaseStateLabel: () => lazyLoadComponent(import('@components/BaseStateLabel')),
    OrderChangeStatusDialog: () => lazyLoadComponent(import('@components/OrderChangeStatusDialog')),
    SignatureDialog: () => lazyLoadComponent(import('@components/SignatureDialog')),
    PetCommentList: () => lazyLoadComponent(import('@components/PetCommentList')),
    NotificationWrite: () => lazyLoadComponent(import('@components/NotificationWrite')),
    DepositOrderForm: () => lazyLoadComponent(import('./DepositOrderForm')),

    /* 重構元件 */
    TotalEdit: () => lazyLoadComponent(import('./components/TotalEdit')),
    AdditionFormOrder: () => lazyLoadComponent(import('./components/AdditionFormOrder')),
    MemberForm: () => lazyLoadComponent(import('./components/MemberForm')),
    MemberInfo: () => lazyLoadComponent(import('./components/MemberInfo')),
    AddressForm: () => lazyLoadComponent(import('./components/AddressForm')),
    RefundForm: () => lazyLoadComponent(import('./components/RefundForm')),
    NoteForm: () => lazyLoadComponent(import('./components/NoteForm')),
    PaymentEditForm: () => lazyLoadComponent(import('./components/PaymentEditForm')),
    PaymentFormDialog: () => lazyLoadComponent(import('./components/PaymentFormDialog')),
    TotalStatementDetail: () => lazyLoadComponent(import('./components/TotalStatementDetail')),
    TotalStatement: () => lazyLoadComponent(import('./components/TotalStatement')),
    OrderMemberInfo: () => lazyLoadComponent(import('./components/OrderMemberInfo')),
    OrderPetInfo: () => lazyLoadComponent(import('./components/OrderPetInfo')),
    PetList: () => lazyLoadComponent(import('./components/PetList')),
    PayList: () => lazyLoadComponent(import('./components/PayList')),
    LeftPetTab: () => lazyLoadComponent(import('./components/LeftPetTab')),
    ReservePersonInfo: () => lazyLoadComponent(import('./components/ReservePersonInfo')),
    UnPaidPrepaidPage: () => lazyLoadComponent(import('./components/UnPaidPrepaidPage')),
    HelperForShow: () => lazyLoadComponent(import('./components/HelperForShow')),
    HelperIcon: () => lazyLoadComponent(import('./components/HelperIcon')),
    HelperSaveCancelBtn: () => lazyLoadComponent(import('./components/HelperSaveCancelBtn')),
    HelperSelectOption: () => lazyLoadComponent(import('./components/HelperSelectOption')),
  },
  filters: {
    orderPaymentMethodFilter,
    formatDate,
    bookingStatusFilter,
    paymentStatusMapFilter,
    genderFilter,
  },
  mixins: [reserveOrder, memberLevelDiscountMixin, orderDetailMixin, helperMixin],
  props: {
    // 是否開啟發票輸入畫面 -> 1 開啟 / 0 關閉
    storeInvoiceSetting: {
      type: Number,
      default: -1,
    },
    defaultValue: {
      type: Object,
      default: () => initData(),
    },
    orderType: {
      type: String,
      validator: (val) => {
        return ['reservation', 'prepaid', 'deposit', 'goods'].includes(val)
      },
      required: true,
    },
    // 判斷是否只是美容師
    isEmployee: {
      type: Boolean,
      default: false,
    },
    guestCheck: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    // 監控activeName，如果回去tab，要清空containerAllItem
    activeName(nvl) {
      if (nvl === '') {
        this.showAllStatus = true
      } else {
        this.showAllStatus = false
      }
      if (nvl !== '') {
        this.containerAllItem = cloneDeep({})
      }
    },
  },
  data() {
    return {
      orderHeaderId: `orderHeader__${Math.floor(Math.random() * 10000)}`,
      orderPaymentMethodMap,
      taxTypeMap,
      carrierTypeMap,
      headerHeight: 0,
      submitData: cloneDeep({
        ...this.defaultValue,
        couponCode: this.defaultValue.coupon ? this.defaultValue.coupon.code : '',
      }),
      childrenSubmitData: cloneDeep({
        ...initChildrenData(),
        ...this.defaultValue,
        Card4No: '',
        PayerAccount5Code: '',
        id: undefined,
        coupon: undefined,
        parentId: this.defaultValue.id,
        params: [],
        prepaidOrderUuid: '',
        paymentStatus: 'UNPAID',
        groupSize: 1,
        scheduleItemId: this.defaultValue.scheduleItem?.id,
        startDate: `${this.defaultValue.date} ${this.defaultValue.time}`,
        petId: this.defaultValue.pet.id,
        type: 'cosmetic',
      }),
      currentOrder: cloneDeep(this.defaultValue),
      couponInfo: {},
      tryingValidCouponCode: false,
      previousCouponCode: '',
      // 各種 show

      // 全畫面
      totalAllShow: false,
      // 右邊的show，左邊有任何選擇，右邊的show要全部關掉
      memberInfoShow: false,
      editDetailEnabled: false,
      visibleAdditionForm: false,
      addressShow: false,

      // totalShow:true,

      // dialog show
      paymentDialogVisible: false,
      // 各種 loading
      tryingStore: false,
      allPageLoading: false,

      paymentWay: 'offline',
      userSameAsMember: true,
      statusDialogVisible: false,

      // params 必須先拆開成 服務 加購 變價，然後變價的排序折扣要在最後面，有變動的時候要按照順序塞回submitData.params

      basePrice: 0,

      componentKey: 0,
      createDepositOrderVisible: false,

      assignList: [], // 助理下拉選單
      editAssistantEnabled: false,
      commentList: [],
      petCommentDialogVisible: false,
      orderRefundShow: false,
      tryingRefund: false,
      noteEditShow: false,
      orderHistoryShow: false,
      editPaymentMethodShow: false, // 編輯付款方式參數
      writeDialogVisible: false,
      tryingSendSMS: false,
      checkinStatusDialogVisible: false,
      checkinStatusDialogVisibleV2: false, // 確認將此訂單改為「已報到」dialog status
      overTimeStatusCalDialog: false, // 超時計算dialog status
      noShowDialogVisible: false,
      checkDialogVisible: false,
      tryingAssign: false, // assign助理 store的api
      tryingAssignList: false, // fetch助理List的api
      addOrderIndex: 'main', // 這種同個資料用兩種型別其實不太對，後續修正
      deleteIds: [],
      deleteCoupon: {},
      shareLink: '',
      shareDialogVisible: false,
      signDialogKey: 0,
      signDialogVisible: false,
      // 會員資訊
      memberInfo: {
        tags: [],
        phoneCode: '',
        phoneNumber: '',
        level: {},
      },
      memberInfoActiveTab: 'information',

      tryingNoShow: false,
      isChildrenOrderCreating: false,
      payMethods: {
        Cash: '到店付款(現金)',
        StoreCredit: '現場刷卡',
        Atm: '線下匯款',
      },
      tryingCheckIn: false,
      tryingPayOrder: false,
      mapStatusName: {
        PAID: '訂單資訊',
        UNPAID: '付款',
      },
      appStyle: process.env.VUE_APP_BUILD_MODE === 'admin-app-build',
      tryingStoreOrderItem: false,

      // 寵物資訊
      petInfoActiveTab: 'information',
      petShow: false,
      // 是否顯示寵物列表
      isShowPetList: false,
      petList: [],
      tabActive: 'reservationOrder',

      // dialogVisible
      isDialogPaidConfirmVisible: false,
      checkResultAndPayStatus: false, // 付款方式視窗
      paidConfirmValue: {},
      activeName: '', // 左側寵物列表的activeName
      cloneActiveName: '', // 先複製起來後還原
      petServiceGroupList: [], // 將寵物group起來的服務列表
      thisTimeSelectedPetInfo: {}, // 這次選到的寵物資訊
      containerOrders: {},
      completeReserveAndPayStatus: false, // 完成預約，立即付款按鈕跳窗出現
      payPersonInfo: {}, // 付款人資訊
      orderContainerUuid: '', // orderContainerId
      selectSingleOrder: false,
      tempOriginalParams: [], // 因為使用者有可能點不同訂單，所以原本新增的要先存起來
      thisTimeModiOrderId: '', // 因為有可能加購不同訂單，所以要先存起來這次想加購哪個訂單
      addMoment: false, // 編輯價格與折扣當下的moment
      selectSingleOrderTempResolveFunc: () => {}, // 價格編輯與折扣點下去後，開啟的選擇單筆drawer
      selectSingleOrderTempRejectFunc: () => {}, // 價格編輯與折扣點下去後，開啟的選擇單筆drawer
      openAssignEditStatus: false, // 開始助理編輯
      openSpaceEditStatus: false, // 開啟空間編輯
      containerEdit: false, // 判斷現在是不是正在container的修改
      containerAllItem: {}, // 查看總訂單時，要「價格編輯」 or「刪除/取消訂單」的總項目
      unPaidPrepaidPageStatus: false, // 前往付款包月訂單是否要顯示
      startTab: 1, // 要讓簽名確認的tab出現在哪個分頁
      signResolveFunc: () => {}, // 發票儲存後要讓PayList繼續做
      signRejectFunc: () => {}, // 發票儲存的上一步，要讓PayList Stop
      showAllStatus: false,
      canAddNewOrder: true, // 可以新增一筆預約
      newOrderInfo: {}, // 新選到服務內的資訊
      checkedItem: [], // 要讓使用者報到的資料
      currentOrderIndex: 0,
      merchantSettingData: {}, // 商家設定
      salonTermsAgree: false, // 美容契約同意
      salonSignatureFile: null, // 美容契約簽名檔
      checkDialogSupplementMode: false, // 補簽名模式
      printHtml: '<h1>美容契約條款</h1><p>測試列印的內容</p>', // 美容契約列印內容
    }
  },
  computed: {
    getInstallmentUnpayCount() {
      let result = this.containerOrders.installments.filter((item) => {
        return item.paymentStatus !== 'PAID'
      }).length
      return result + '期'
    },
    computedParentContainerIsTemp() {
      let status = true
      if (Object.keys(this.containerOrders).length > 0 && this.containerOrders.is_temp === 1) {
        status = false
      }
      this.$store.commit('modifyOrder/TEMP_ORDER_CHECK', status)
      return status
    },
    /**
     * @description 決定是否是付款
     */
    containerIsTempToPay() {
      if (this.computedFreeService) {
        return '完成預約，下一步'
      } else {
        return this.containerOrders.is_temp === 0 ? (this.containerOrders.paymentMethod === 'Installment' ? '付款分期' : '付款') : '完成預約，下一步'
      }
    },
    /**
     * @description 如果是免費的 && 卡單狀態下，是否顯示完成預約下一步
     */
    computedFreeService() {
      if (
        this.testUnpaidContainer.childTotal === 0 &&
        this.testUnpaidContainer.parentTotal === 0 &&
        this.paidAndUnPaidSummary.unPaid === 0 &&
        this.paidAndUnPaidSummary.paid === 0 &&
        Object.keys(this.containerOrders).length > 0 &&
        this.containerOrders.is_temp === 1
      ) {
        return true
      } else {
        return false
      }
    },
    checkSign() {
      if (this.activeName === '') {
        return false
      } else {
        return (
          this.thisChildContainerHasPaid &&
          this.thisParentContainerHasPaid &&
          this.seeSingleOrderIng &&
          !this.testPrepaidOrderNotCheck && // 包月是否都已經付款
          this.containerOrders.is_temp === 0 &&
          this.defaultValue.status === 4
        )
      }
    },
    seeSingleOrderIng() {
      if (this.activeName === '') {
        return false
      }
      if (this.activeName !== '' && !this.submitData.signature) {
        return true
      }
      return false
    },
    /**
     * @description 母訂單是否全部被付款了
     */
    thisParentContainerHasPaid() {
      let payStatus = false
      if (Object.keys(this.containerOrders).length > 0) {
        const { orders } = this.containerOrders
        payStatus = orders.filter((x) => x.status !== 0).every((x) => x.paymentStatus === 'PAID')
      }
      return payStatus
    },
    /**
     * @description 查看子訂單是否被付款，是就要出現簽名確認
     */
    thisChildContainerHasPaid() {
      let payStatus = false
      if (Object.keys(this.containerOrders).length > 0) {
        const { orders } = this.containerOrders
        payStatus = orders.every((x) => {
          const { childrenOrders } = x
          return childrenOrders.filter((y) => y.status !== 0).every((y) => y.paymentStatus === 'PAID')
        })
      }
      // return true：代表不為取消的都已經付款了
      return payStatus
    },
    thisChildContainerIsTemp() {
      try {
        if (Object.keys(this.containerOrders).length === 0) return ''
        const { orders } = this.containerOrders
        orders.forEach(function(item) {
          const { childrenOrders } = item
          if (childrenOrders.some((innerItem) => innerItem.orderContainerIsTemp === 1)) {
            throw new Error('StopIteration')
          }
        })
      } catch (e) {
        if (e.message !== 'StopIteration') {
          throw e
        }
        return {
          text: '確認子訂單 & 選擇付款方式',
          status: true,
        }
      }
      return {
        text: '付款子訂單',
        status: false,
      }
    },
    /**
     * @description 這個畫面有新訂單
     */
    haveNewOrder() {
      return 0
    },
    editServiceTotal() {
      let cacheTotal = 0
      if (this.prepaidItem) {
        cacheTotal = 0
      } else if (this.isCouponUsed && !this.hasDeleteCoupon) {
        cacheTotal = this.reservationTotal - this.couponItem.discountValue
      } else if (this.hasCouponInfo) {
        cacheTotal = this.couponPriceTotal
      } else {
        cacheTotal = this.reservationTotal
      }
      return cacheTotal
    },
    editOrderDate() {
      return formatDate(`${this.defaultValue.date} ${this.defaultValue.time}`, 'dateTime')
    },
    childrenOrders() {
      return this.defaultValue.childrenOrders.length > 0 ? this.defaultValue.childrenOrders : []
    },
    childrenOrdersHaveInvoice() {
      return this.childrenOrders.filter((item) => !!item.invoice.InvoiceNumber)
    },
    helpSubmitRules() {
      return {
        helperId: [
          {
            required: true,
            message: '請選擇助理',
            trigger: 'change',
          },
        ],
      }
    },
    currentHistory() {
      return this.currentOrder.history
    },
    unPaidAddOrder() {
      return this.childrenOrders.find((item) => {
        return item.paymentStatus === 'UNPAID' && item.status !== 0
      })
    },
    isMainOrder() {
      return this.addOrderIndex === 'main'
    },
    prepaidItem() {
      return this.defaultValue.params.find((item) => {
        return item.type === 'prepaid'
      })
    },
    isCouponUsed() {
      return Object.keys(this.couponItem).length > 0
    },
    hasDeleteCoupon() {
      return this.deleteCoupon.id !== undefined
    },
    reservationItem() {
      return this.defaultValue.params.find((item) => {
        return item.type === 'cosmetic'
      })
    },
    goodsItem() {
      return this.defaultValue.params.find((item) => {
        return item.type === 'goods'
      })
    },
    isCouponEditable() {
      const isPrepaidPayment = this.currentOrder.prepaidOrderUuid
      return !this.isPaid && this.reservationTotal > 0 && !isPrepaidPayment && this.isMainOrder
    },
    /************ 寵物資訊相關 start ************/
    personalityContentOrder() {
      return this.defaultValue.pet.questions.personality.join('，')
    },
    healthyContentOrder() {
      const content = this.defaultValue.pet.questions.healthy.map((item) => {
        return `${item.title}${item.text ? ' ( ' : ''} ${item.text ? item.text : ''}${item.text ? ' )' : ''}`
      })
      return content.join('，')
    },
    behaviorContentOrder() {
      const content = this.defaultValue.pet.questions.behavior.map((item) => {
        return `${item.title}${item.text ? ' ( ' : ''} ${item.text ? item.text : ''}${item.text ? ' )' : ''}`
      })
      return content
    },
    vaccineContentOrder() {
      let vaccine = ''
      switch (this.defaultValue.pet.questions.vaccine) {
        case 1:
          vaccine = '1 劑'
          break
        case 2:
          vaccine = '2 劑'
          break
        case 3:
          vaccine = '3 劑'
          break
        default:
          break
      }
      return vaccine
    },
    depositReduce() {
      if (this.memberInfo.depositInfo === undefined) return 0

      const { bonus, point } = this.memberInfo.depositInfo.solution2.reduceDepositTotal
      return bonus + point
    },
    isHomeService() {
      return this.defaultValue.storeType === 'home'
    },
    isPaid() {
      return this.defaultValue.paymentStatus === 'PAID'
    },
    petSizeId() {
      return this.defaultValue.pet.sizeId
    },
    petCategoryId() {
      return this.defaultValue.pet.categoryId
    },
    submitRules() {
      const isTaiwan = this.submitData.phoneCode === '+886'
      /* let validCodeTimeout = '' */
      return {
        phoneNumber: [
          {
            required: true,
            message: '請填寫手機號碼',
            trigger: 'blur',
          },
          {
            pattern: isTaiwan ? /^09\d{8}$/ : '',
            message: '格式請符合 09XXXXXXXX',
            trigger: 'blur',
          },
        ],
        email: [
          {
            required: true,
            message: '請輸入 Email',
          },
          {
            type: 'email',
            message: '請輸入正確的 Email 格式',
          },
        ],
        fullName: [
          {
            required: true,
            message: '請輸入使用人姓名',
          },
        ],
        gender: [
          {
            required: true,
            message: '請選擇性別',
          },
        ],
        productId: [
          {
            required: true,
            message: '請選擇服務地點',
          },
        ],
        productId2: [
          {
            required: true,
            message: '請選擇服務地點',
          },
        ],
        params: [
          {
            required: true,
            message: '請選擇服務項目',
          },
        ],
        bankType: [
          {
            required: true,
            message: '請選擇轉帳銀行',
          },
        ],
        petId: [
          {
            required: true,
            message: `請選擇${this.$t('reserve.CLIENT')}`,
          },
        ],
        city: [
          {
            required: this.isHomeService,
            message: '請選擇縣市',
          },
        ],
        district: [
          {
            required: this.isHomeService,
            message: '請選擇區域',
          },
        ],
        address: [
          {
            required: this.isHomeService,
            message: '請輸入服務地址',
            trigger: 'blur',
          },
        ],
        prepaidOrderUuid: [
          {
            required: this.isRequiredPrePaid,
            message: `請選擇${this.$t('prepaid.BASE')}方案`,
            trigger: 'change',
          },
        ],
        couponCode: [
          {
            validator: (rule, value, callback) => {
              try {
                if (value === undefined) {
                  return
                }
                if (value === '') {
                  this.$refs.couponForm.clearValidate('couponCode')
                  return callback()
                }
                if (this.previousCouponCode === value) {
                  return callback()
                }
                this.previousCouponCode = value
                if (value === this.couponItem.code) {
                  const resetDeleteCoupon = () => {
                    const { id: couponId } = this.defaultValue.params.find(({ type }) => type === 'coupon')
                    if (couponId === this.deleteCoupon.id) this.deleteCoupon = {}
                  }
                  resetDeleteCoupon()
                  callback()
                  this.applyCoupon({ ...this.couponItem })
                } else {
                  this.tryingValidCouponCode = true
                  this.$store
                    .dispatch('coupon/validCode', {
                      code: value,
                      basePrice: this.submitData.params[0].total,
                      priceId: this.submitData.params[0].priceId,
                      memberId: this.memberInfo.id,
                    })
                    .then((response) => {
                      callback()
                      this.applyCoupon(response.items)
                    })
                    .catch((error) => {
                      this.previousCouponCode = ''
                      callback(new Error(formatStatusMessage(error.status)))
                    })
                    .finally(() => {
                      this.tryingValidCouponCode = false
                    })
                }
              } catch (error) {
                console.error(error.message)
              }
            },
            trigger: 'custom',
          },
        ],
      }
    },
    // 新增訂單時已使用優惠券
    couponItem() {
      return this.defaultValue.coupon || {}
    },
    hasCouponInfo() {
      return Object.keys(this.couponInfo).length !== 0
    },
    couponPriceTotal() {
      const calcFixedDiscount = (value = 0, total = 0) => {
        return total - value < 0 ? 0 : total - value
      }
      const calcPercentDiscount = (value = 0, total = 1) => {
        return total - Math.round(total * (value / 100))
      }
      const basePriceTotal = this.reservationTotal
      const { discount, type } = this.couponInfo

      return this.couponInfo ? (type === 'fixed' ? calcFixedDiscount(discount, basePriceTotal) : calcPercentDiscount(discount, basePriceTotal)) : basePriceTotal
    },
    /**
     * @description 需要提交出去的priceTotal
     */
    submitPriceTotal() {
      this.currentOrder.params.forEach((item) => {
        if (item.type === 'cosmetic' && item.priceId !== 'fake') {
          item.priceId = parseInt(item.priceId)
        }
      })
      let total = parseInt(this.editServiceTotal)
      const parentMemberLevelDiscount = this.composeMemberLevelDiscount(this.currentOrder.params[0])
      const memberLevelPercent = typeof parentMemberLevelDiscount === 'object' ? parentMemberLevelDiscount : 0
      if (!this.isChildrenOrderCreating) {
        if (!this.isMainOrder) {
          total = 0
        }
        this.updateBasePrice()
        total = calcTotal({ price: total, totalEditList: this.currentOrder.params, memberLevelPercent, memberInfo: this.memberInfo })
      }
      return total
    },
    hasCannotPayByDepositAddition() {
      /* 未來加購項目可能也可以設定成適用項目 */
      // return this.additionList.some((item) => !item.canPayByDeposit)
      return false
    },
    linkTitle() {
      const { childrenOrders } = this.defaultValue
      if (childrenOrders.length) {
        let hasUnpaid = false
        hasUnpaid = childrenOrders.some((order) => order.paymentStatus === 'UNPAID')
        return this.mapStatusName[hasUnpaid ? 'UNPAID' : 'PAID']
      } else return this.mapStatusName[this.defaultValue.paymentStatus]
    },
    /* 會員等級效期 */
    validityTime() {
      const startedAt = this.memberInfo.level.startedAt
      const expiredAt = this.memberInfo.level.expiredAt
      return membreLevelValidityTime(startedAt, expiredAt)
    },
    // 訂單類型
    detailTypeCheck() {
      if (this.isMixinOrders && this.currentSelectOrder.length) {
        return this.currentSelectOrder[0].params[0].type === 'goods' ? 'goods' : 'reservation'
      }
      return this.defaultValue.params[0].type === 'goods' ? 'goods' : 'reservation'
    },
    // 判斷是否為商品與服務的混合訂單
    isMixinOrders() {
      if (!Object.keys(this.containerOrders).length) return false
      const types = this.containerOrders.orders.map((order) => order.params[0]?.type)
      const result = new Set(types)
      return result.size > 1
    },
    // 當前選擇tab的訂單內容
    currentSelectOrder() {
      this.currentOrderIndex = 0
      if (!Object.keys(this.containerOrders).length) return []
      // 非混合訂單
      if (!this.isMixinOrders) {
        return this.orderType === 'goods' ? this.containerOrders.orders : this.containerOrders.orders.filter((order) => this.petServiceGroupList.find((item) => item.orderId === order.id))
      }
      // 混合訂單
      if (this.tabActive === 'reservationOrder') return this.containerOrders.orders.filter((order) => this.petServiceGroupList.find((item) => item.orderId === order.id))
      if (this.tabActive === 'goodsOrder') {
        if (this.isMixinOrders) return this.containerOrders.orders.filter((item) => item.params[0].type === 'goods')
        return this.containerOrders.orders
      }
    },
    // 確認是否由分期付款訂單頁面進入PayList
    orderPaying() {
      return this.containerOrders.paymentMethod === 'Installment' && this.containerOrders.installments.length > 0
    },
    messageData() {
      return {
        姓名: this.defaultValue.fullName,
        訂單成立時間: this.defaultValue.created,
        店家名稱: this.defaultValue.productName,
        預約時間: `${this.defaultValue.date} ${this.defaultValue.time}`,
        付款時間: this.defaultValue.paidAt || '尚未付款',
        服務項目: this.defaultValue.params[0].title,
      }
    },
    getBottomBtnType() {
      if (this.computedFreeService && this.thisParentContainerHasPaid) return 'primary'
      if (!this.thisParentContainerHasPaid && this.containerOrders.paymentMethod === 'Installment') return 'success'
      if (!this.thisParentContainerHasPaid && this.containerOrders.paymentMethod !== 'Installment') return 'primary'
      return ''
    },
    terms() {
      return this.merchantSettingData.items?.terms || ''
    },
    showServiceContractSignatureSection() {
      return [4, 6].includes(this.defaultValue.status)
    },
  },
  async mounted() {
    const updateHeaderHeight = () => {
      this.$nextTick(async () => {
        const interval = setInterval(() => {
          if (document.querySelector(`#${this.orderHeaderId}`) !== null) {
            clearInterval(interval)
            this.headerHeight = document.querySelector(`#${this.orderHeaderId}`).offsetHeight + 40
          }
        }, 500)
      })
    }
    this.allPageLoading = true
    await this.fetchExtraInfo()
    await this.getContainerUuid() // 先取得containerID
    await this.initTab() // 初始化tab
    this.allPageLoading = false
    this.updateCoupon()
    updateHeaderHeight()
  },
  beforeDestroy() {
    this.isExpired = true
    clearInterval(this.timer) // 在组件销毁之前清除计时器
  },
  methods: {
    /**
     * @description 開啟指定or不指定
     */
    openSpecifyFun(item) {
      this.$set(item, 'specifyVisible', true)
      this.openAssignEditStatus = false
      this.openSpaceEditStatus = false
    },
    /**
     * @description 儲存指定修改
     */
    async tryToStoreSpecify(storeData) {
      try {
        this.tryingAssign = true
        await this.$store.dispatch('order/store', storeData)
        await this.updateOrder() // 要更新訂單 改這個等於是改訂單
        await this.getContainerUuid()
        await this.initTab() // 初始化tab
      } catch (error) {
        console.error(error.message)
      } finally {
        this.tryingAssign = false
      }
    },
    /**
     * @description 簽名確認是否要出現
     */
    signaturBtnShow(item) {
      try {
        // 原簽名確認判斷條件式
        const unPaidAddOrder = (innerItem) => {
          return innerItem.childrenOrders.find((item) => {
            return item.paymentStatus === 'UNPAID' && item.status !== 0
          })
        }
        const { orderDetail } = item
        if (orderDetail.status === 4 && orderDetail.paymentStatus === 'PAID' && !unPaidAddOrder(orderDetail) && orderDetail.prepaidOrderStatus !== 2) {
          return true
        } else {
          return false
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 開啟前往付款包月訂單
     */
    goPayPrepaid() {
      this.unPaidPrepaidPageStatus = true
    },
    async renewContainerOrders() {
      await this.getContainerUuid()
    },
    /**
     * @description 如果判定訂單是最後一筆，則刪除localStorage的member Info
     */
    async deleteLocalStorage() {
      try {
        const { childrenOrders } = this.containerOrders.orders[0]
        if (this.containerOrders.orders.length === 1 && childrenOrders.length === 0) {
          await saveState('containerMemberId', '')
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 開窗流程
     */
    async openDrawerSchedule() {
      this.allPageLoading = true
      await this.fetchExtraInfo()
      await this.getContainerUuid() // 先取得containerID
      await this.initTab() // 初始化tab
      this.allPageLoading = false
      this.updateCoupon()
    },
    /**
     * @description 僅僅單筆預約，然後cb是做checkout container
     */
    async storeSingleOrder(cb) {
      try {
        const { type } = this.submitData.params[0]
        // 然後要找出params的第一筆type
        this.$set(this.submitData, 'type', type)
        // 因為是單筆預約，要放入container，所以要將paymentMethod先清空
        this.$set(this.submitData, 'paymentMethod', '')
        await cb()
        this.checkResultAndPayStatus = false
        this.completeReserveAndPayStatus = false
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 完成預約立即付款
     */
    completeReserveAndPay() {
      this.completeReserveAndPayStatus = true
    },
    async initTab() {
      try {
        const { pet } = this.defaultValue
        const { id } = pet
        const petTabIndex = this.containerGroupPetIdForDetail.findIndex((item) => item.id === id)
        this.activeName = `${+petTabIndex}`
        await this.handleClickPetTabForDetail()
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description update此頁面點選到的tab
     */
    updateActiveNameForDetail(nvl) {
      this.activeName = nvl
    },
    /**
     * @description 點完tab之後要做的事，更新所有服務
     */
    async handleClickPetTabForDetail() {
      try {
        this.handleClickPetTabMixin(this.containerGroupPetIdForDetail, 'detail') // 找到clickTab下去的寵物細節
        this.findPetServiceGroup()
        if (this.petServiceGroupList.length > 0) {
          await this.seeOrder(this.petServiceGroupList[0])
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 查看總訂單
     */
    async showAll(allOrdersStatus) {
      try {
        // true 代表正在看總訂單
        if (allOrdersStatus) {
          this.activeName = ''
          this.findPetServiceGroupForAll()
          if (this.petServiceGroupList.length > 0) {
            // 找到第一筆未取消的訂單
            const itemIndex = this.petServiceGroupList.findIndex((item) => item.hasOwnProperty('name'))
            // 如果 > -1 代表有找到未取消訂單，則繼續下去
            if (itemIndex > -1) {
              await this.seeOrder(this.petServiceGroupList[itemIndex])
            } else {
              // 但是如果沒找到，就要預設第0筆資料
              await this.seeOrder(this.petServiceGroupList[0])
            }
          }
        } else {
          this.activeName = '0'
          await this.handleClickPetTabForDetail()
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 查看訂單
     */
    async seeOrder(item, type, index) {
      try {
        this.allPageLoading = true

        // 切換訂單明細
        if (index || index === 0) this.currentOrderIndex = index
        // 從加購來的查看訂單(for 子訂單)
        if (Object.keys(item).length > 0 && type && type === 'add' && item.parentId !== null) {
          item['orderId'] = item.parentId
          this.addMoment = true
          this.$emit('onlyFetchSingleOrder', item.orderId, () => this.updateSubmitData())
          this.allPageLoading = false
        }
        // 給右下角的查看訂單使用
        if (Object.keys(item).length > 0 && !type) {
          this.$emit('onlyFetchSingleOrder', item.orderId, () => this.updateSubmitData())
          this.allPageLoading = false
        }
        // 給母訂單的加購
        if (Object.keys(item).length > 0 && type && type === 'add' && item.parentId === null) {
          item['orderId'] = item.id
          this.addMoment = true
          this.$emit('onlyFetchSingleOrder', item.orderId, () => this.updateSubmitData())
          this.allPageLoading = false
        }
        // 總訂單時的加購
        if (Object.keys(item).length === 0 && type && type === 'add') {
          const result = this.decideIdAndParams()
          this.$set(this.currentOrder, 'id', result.id)
          this.$set(this.currentOrder, 'params', result.params)
          this.selectSingleOrderTempRejectFunc()
          this.selectSingleOrder = false
          this.containerEdit = true
          this.allPageLoading = false
        }
      } catch (error) {
        console.error(error.message)
      } finally {
        this.allPageLoading = false
      }
    },
    /**
     * @description 決定要顯示哪個總訂單的資訊
     */
    decideIdAndParams() {
      try {
        let result = {
          id: '',
          params: [],
          total: 0,
        }
        // 子container的加減價
        if (this.addOrderIndex !== 'main') {
          const { items } = this.containerOrders.childrenOrderContainers
          const childNotPaidIndex = items.findIndex((item) => item.displayId === this.testUnpaidContainer.childOrderId)
          result['id'] = items[childNotPaidIndex]['displayId']
          result['params'] = cloneDeep(items[childNotPaidIndex]['params'])
          result['total'] = items[childNotPaidIndex]['orders'].reduce((accu, cur) => {
            return accu + cur.payTotal
          }, 0)
        }
        // 母container的加減價
        if (this.addOrderIndex === 'main') {
          result['id'] = this.testUnpaidContainer.parentOrderId ?? this.testUnpaidContainer.childOrderId
          result['params'] = cloneDeep(this.containerOrders['params'])
          result['total'] = this.containerOrders['orders'].reduce((accu, cur) => {
            return accu + cur.payTotal
          }, 0)
        }
        result['params'].unshift({
          type: 'cosmetic',
          title: '總價',
          priceId: 'fake',
          price: result['total'],
          qty: 1,
          total: result['total'],
        })
        return result
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 更新submitData
     */
    updateSubmitData() {
      try {
        this.$nextTick(async function() {
          // 如果helper 還沒有，那就先建立假的
          if (!this.defaultValue.helper) {
            this.defaultValue.helper = {
              id: '',
              name: '',
            }
            this.defaultValue.helpers = [
              {
                id: '',
                name: '',
              },
            ]
          }
          this.submitData = cloneDeep({
            ...this.defaultValue,
            couponCode: this.defaultValue.coupon ? this.defaultValue.coupon.code : '',
          })
          this.childrenSubmitData = cloneDeep({
            ...initChildrenData(),
            ...this.defaultValue,
            Card4No: '',
            PayerAccount5Code: '',
            id: undefined,
            coupon: undefined,
            parentId: this.defaultValue.id,
            params: [],
            prepaidOrderUuid: '',
            paymentStatus: 'UNPAID',
            groupSize: 1,
            scheduleItemId: this.defaultValue.scheduleItem?.id,
            startDate: `${this.defaultValue.date} ${this.defaultValue.time}`,
            petId: this.defaultValue.pet.id,
            type: 'cosmetic',
          })
          // 如果是加購要多做這邊
          if (this.addMoment) {
            this.currentOrder = Object.assign({}, this.submitData)
            this.selectSingleOrder = false
            this.addMoment = false
          }
          // 總訂單編輯價格與折扣走這
          if (this.addOrderIndex !== 'main') {
            this.selectSingleOrderTempResolveFunc()
          }
          // 都更新之後，要再搜尋助理的清單
          if (this.openAssignEditStatus) {
            await this.tryToFetchHelperList(0)
            this.openAssignEditStatus = false
          }
          // 都更新之後，如果是空間，要在搜尋空間的清單
          if (this.openSpaceEditStatus) {
            await this.tryToFetchHelperList(1)
            this.openSpaceEditStatus = false
          }
          this.allPageLoading = false
        })
      } catch (error) {
        console.error(error.message)
      }
    },
    async handleStoreOrder() {
      const isBeforeExpired = this.memberInfo.level.expiredAt === null || new Date() <= new Date(formatGetTime(this.memberInfo.level.expiredAt))
      if (!isBeforeExpired) return this.errorCurrentMemberLevel()
      const isNegative = this.isChildrenOrderCreating ? this.childrenOrderTotal < 0 : this.submitPriceTotal < 0

      if (isNegative) {
        this.$confirm('訂單金額不能小於0', '提醒', {
          confirmButtonText: '確定',
          showCancelButton: false,
          type: 'warning',
          center: true,
        })
        return
      }

      if (this.paymentWay === 'Deposit') {
        this.handleDepositPayment()
      } else {
        this.paymentDialogVisible = true
      }
    },
    async handleDepositPayment() {
      const mainOrderTotal = this.submitPriceTotal
      const isDepositInsufficient = this.isChildrenOrderCreating ? this.depositReduce < this.childrenOrderTotal : this.depositReduce < mainOrderTotal

      if (this.isChildrenOrderCreating) {
        if (this.hasCannotPayByDepositAddition) {
          await this.$confirm(`加購項目中某幾項未設定可使用儲值點數抵扣，請問是否確定抵扣 ${this.childrenOrderTotal} 點？`, '抵扣未開放', {
            confirmButtonText: '確定',
            type: 'warning',
            center: true,
          })
        } else {
          await this.$confirm(`確定要使用儲值金抵扣 ${this.childrenOrderTotal} 點？`, '提醒', {
            confirmButtonText: '確定',
            type: 'warning',
            center: true,
          })
        }
      } else if (this.reservationItem.canPayByDeposit === false) {
        await this.$confirm(`${this.hasCannotPayByDepositAddition ? '加購項目中某幾項' : '此方案'}未設定可使用儲值點數抵扣，請問是否確定抵扣 ${mainOrderTotal} 點？`, '抵扣未開放', {
          confirmButtonText: '確定',
          type: 'warning',
          center: true,
        })
      } else {
        await this.$confirm(`確定要使用儲值金抵扣 ${mainOrderTotal} 點？`, '提醒', {
          confirmButtonText: '確定',
          type: 'warning',
          center: true,
        })
      }

      if (isDepositInsufficient) {
        await this.$confirm(`儲值金餘額不足，是否加值`, '提醒', {
          confirmButtonText: '確定',
          // showCancelButton: false,
          type: 'warning',
          center: true,
        })
        this.createDepositOrderVisible = true
        return
      }

      this.childrenSubmitData.paymentMethod = 'Deposit'

      this.tryToCreateChildrenOrder()
    },
    /**
     * @description 點擊右邊[+ 新增子訂單] -> 開啟drawer後的 -> [新增子訂單]
     */
    async onlyCreateChildrenOrder() {
      try {
        const result = await this.negativeAlert(this.childrenOrderTotal)
        if (!result) return
        this.allPageLoading = true
        this.updateBasePrice(true)
        let storeData = {
          ...this.childrenSubmitData,
          basePrice: this.basePrice,
          total: this.childrenOrderTotal,
        }
        delete storeData.status
        if (this.orderContainerUuid.length > 0) {
          storeData.paymentMethod = ''
          storeData.paymentStatus = 'UNPAID'
        }
        await this.$store.dispatch('order/store', storeData)
        this.closeChildren()
        this.activeName = '0' // 先將activeName變成0
        await this.updateOrder()
        await this.getContainerUuid() // 先取得containerID
        await this.handleClickPetTabForDetail()
      } catch (error) {
        console.error(error.message)
      } finally {
        this.allPageLoading = false
      }
    },
    /**
     * @description 簽完名確認送出後的流程
     */
    async signatureUpdate() {
      await this.updateOrder()
      await this.openDrawerSchedule()
    },
    /**
     * @description 創造子訂單
     */
    async tryToCreateChildrenOrder() {
      let storeData = {
        ...this.childrenSubmitData,
        basePrice: this.basePrice,
        total: this.childrenOrderTotal,
      }
      delete storeData.status
      if (this.orderContainerUuid.length > 0) {
        storeData.paymentMethod = ''
        storeData.paymentStatus = 'UNPAID'
      }
      this.tryingStore = true
      try {
        await this.$store.dispatch('order/store', storeData)
        let requirePay = storeData.paymentStatus === 'PAID' ? false : storeData.paymentStatus === 'UNPAID' && storeData.total > 0

        this.handleCreateSuccess(requirePay)
        this.paymentDialogVisible = false
        this.closeChildren()
        await this.updateOrder()
      } catch (error) {
        if (error.status === 'SCHEDULE_ITEM_CALENDAR_TIME_UNAVAILABLE')
          this.$message({
            type: 'warning',
            message: `與該訂單時段重疊： ${formatDate(new Date(error.data.date), 'dateTime')}`,
          })
        if (error.status === 'SCHEDULE_ITEM_ADMIN_ITEM_NOT_EXIST')
          this.$message({
            type: 'error',
            message: `此排班不存在或該排班人員不存在`,
          })
        else
          this.$message({
            type: 'error',
            message: `Server Error`,
          })
      } finally {
        this.tryingStore = false
      }
    },
    handleCreateSuccess(requirePay = false) {
      this.emitStore()
      this.$alert(`已發送${requirePay ? '付款' : '訂單'}連結至使用人 Email`, '訂單新增成功！', {
        confirmButtonText: '確認',
        center: true,
      })
    },
    onSubmitPaymentForm(data) {
      const { paymentMethod, Card4No, PayerAccount5Code, bankType, isPaid } = data
      this.childrenSubmitData = {
        ...this.childrenSubmitData,
        paymentMethod,
        Card4No,
        PayerAccount5Code,
        bankType,
        paymentStatus: isPaid ? 'PAID' : 'UNPAID',
      }

      this.tryToCreateChildrenOrder()
    },
    emitStore() {
      this.statusDialogVisible = false
      this.$emit('closeTabProductDetail')
      this.$emit('store')
    },
    openTotalEdit() {
      this.totalAllShow = true
      this.visibleAdditionForm = false
    },
    /**
     * @description 開啟右方加購
     */
    openAddEdit() {
      this.totalAllShow = true
      this.visibleAdditionForm = true
    },
    closeAdd() {
      this.visibleAdditionForm = false
    },
    /**
     * @description 關閉加價視窗
     */
    async cancelToTalEdit({ resetCoupon = true } = {}) {
      try {
        if (resetCoupon) this.updateCoupon()
        this.totalAllShow = false
        this.activeName = '0'
        await this.handleClickPetTabForDetail()
      } catch (error) {
        console.error(error.message)
      }
    },
    applyCoupon(couponData) {
      this.couponInfo = couponData
    },
    validCoupon() {
      try {
        this.$refs.couponForm.validateField('couponCode')
      } catch (error) {
        console.error(error.message)
      }
    },
    resetCoupon() {
      try {
        this.couponInfo = {}
        this.previousCouponCode = ''
        this.$refs.couponCode.resetField('couponCode') // 留意
        this.submitData.couponCode = '' // resetField 有時不會work 所以還要清空couponCode
        if (this.couponItem) {
          const { total: price, ...other } = this.couponItem
          const id = this.defaultValue.params.find(({ type }) => type === 'coupon').id
          this.deleteCoupon = {
            ...other,
            price,
            id,
          }
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    openAddressEdit() {
      this.closeLayout()
      this.addressShow = true
    },
    closeAddress() {
      this.addressShow = false
    },
    async saveHomeAddress({ syncAddress, data }) {
      const { city, district, address } = data
      this.currentOrder.city = city
      this.currentOrder.district = district
      this.currentOrder.address = address
      this.tryToSaveOrder()
    },
    async onCreateDepositOrderDone() {
      this.$refs.depositOrderForm.closeDrawer()
      await this.tryToFetchDetail(this.memberInfo.id)
      await this.openDrawerSchedule()
    },
    closeLayout() {
      this.editDetailEnabled = false
      this.memberInfoShow = false
      this.addressShow = false
      this.visibleAdditionForm = false

      this.noteEditShow = false
    },
    updateCoupon() {
      try {
        if (this.submitData.coupon) {
          this.couponInfo = { ...this.submitData.coupon }
          this.submitData.couponCode = this.submitData.coupon.code
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    async fetchExtraInfo() {
      await Promise.all([this.tryToFetchDetail(this.defaultValue.memberId)])
    },
    goToDetail() {
      this.closeAllInfo()
      this.memberInfoShow = true
    },
    closeAllInfo() {
      this.memberInfoShow = false
      this.noteEditShow = false
    },
    async tryToRefund(refundData) {
      const order = this.currentOrder.orderContainerDisplayId ? this.currentOrder : this.defaultValue
      if (refundData.paymentMethod !== 'Deposit') {
        // 輸入金額小於等於上限，且大於建議值表示會虧本
        if (refundData.amount <= order.backBalance && refundData.amount > order.recommendRefundValue.amount) {
          await this.$confirm('虧本', '提示', {
            confirmButtonText: '確定',
            type: 'warning',
            center: true,
          })
        } else if (refundData.amount > order.backBalance) {
          // 輸入金額大於上限
          await this.$confirm('退款金額不能超過退款上限', '提示', {
            confirmButtonText: '確定',
            showCancelButton: false,
            type: 'warning',
            center: true,
          })
          return
        }
      } else {
        if (refundData.amount > order.recommendRefundValue.amount) {
          await this.$confirm('虧本', '提示', {
            confirmButtonText: '確定',
            type: 'warning',
            center: true,
          })
        }
      }
      try {
        this.tryingRefund = true
        await this.$store.dispatch('order/refundOrder', {
          id: order.orderContainerDisplayId,
          refundData: refundData,
        })
        this.$confirm('退款已完成', '提示', {
          confirmButtonText: '關閉',
          showCancelButton: false,
          type: 'success',
          center: true,
        })
        await this.updateOrder()
        this.orderRefundShow = false
        await this.tryToFetchDetail(this.memberInfo.id)
        await this.openDrawerSchedule()
      } catch (error) {
        console.error('TCL: refundOrder -> error', error)
      } finally {
        this.tryingRefund = false
      }
    },
    closeOpenRefund() {
      this.orderRefundShow = false
    },
    closeHistory() {
      this.orderHistoryShow = false
    },
    /**
     * @description 開啟加購選擇單筆之前，先做這個
     */
    async editOpenTotalEditSelectTemp(index) {
      return new Promise((resolve, reject) => {
        this.selectSingleOrder = true
        this.selectSingleOrderTempResolveFunc = () => {
          this.selectSingleOrder = false
          resolve()
        }
        this.selectSingleOrderTempRejectFunc = () => {
          reject()
        }
      })
    },
    /**
     * @description 位置：右上角，開啟「編輯價格與折扣」
     */
    async editOpenTotalEdit(index) {
      this.containerEdit = false
      this.totalAllShow = true
      // 首先判斷是母訂單還是子訂單
      if (index === 'main') {
        this.selectSingleOrder = true
        this.addOrderIndex = index
        this.currentOrder = cloneDeep(this.defaultValue) // 如果同時有編輯多個地方 用submitData會存到我當下沒有想要存的東西，所以複製defaultValue來改比較好
      } else {
        this.addOrderIndex = index
        await this.editOpenTotalEditSelectTemp(index)
        // 這邊要filter出來是哪個子訂單
        if (this.activeName === '') {
          this.currentOrder = cloneDeep(this.childrenOrders.find((item) => item.paymentStatus === 'UNPAID'))
        } else {
          this.currentOrder = cloneDeep(this.childrenOrders[index])
        }
      }
      let list = [...this.currentOrder.params]
      if (index === 'main') {
        list.splice(0, 1)
        list.forEach((item, index) => {
          if (item.type === 'coupon') {
            list.splice(index, 1)
          }
        })
        list.forEach((item, index) => {
          if (item.type === 'prepaid') {
            list.splice(index, 1)
          }
        })
      }

      list = list.map((item) => {
        let { total, ...other } = item
        if (item.type === '-') {
          total = -total
        }
        if (item.type === '%') {
          total = parseInt(item.description)
        }
        return {
          ...other,
          price: total,
        }
      })
      this.deleteIds = []
    },
    /**
     * @description 編輯付款方式表格出現
     */
    editOpenPaymentMethod(index) {
      if (this.containerOrders.is_temp) {
        this.$message('請先完成預約')
        return
      }
      if (index === 'main') {
        this.addOrderIndex = index
        this.currentOrder = cloneDeep(this.defaultValue)
        // 取得 bankType
        delete this.currentOrder.bankType
        if (this.currentOrder.Vacc) {
          this.currentOrder = {
            ...this.currentOrder,
            bankType: this.currentOrder.Vacc.BankType,
          }
        }
      } else {
        this.addOrderIndex = index
        this.currentOrder = cloneDeep(this.childrenOrders[index])
        // 取得 bankType
        delete this.currentOrder.bankType
        if (this.currentOrder.Vacc) {
          this.currentOrder = {
            ...this.currentOrder,
            bankType: this.currentOrder.Vacc.BankType,
          }
        }
      }

      this.editPaymentMethodShow = true
    },
    editOpenHistory(index) {
      if (index === 'main') {
        this.addOrderIndex = index
        this.currentOrder = cloneDeep(this.defaultValue)
      } else {
        this.addOrderIndex = index
        this.currentOrder = cloneDeep(this.childrenOrders[index])
      }

      this.orderHistoryShow = true
    },
    /**
     * @description 從子元件打上來的container細節（只有在觀看總訂單時才會有用）
     */
    emitContainerId(containerAllItem) {
      this.containerAllItem = containerAllItem
    },
    /**
     * @description 取消訂單/刪除訂單
     */
    tryToCancelOrder(index) {
      if (index === 'main') {
        this.addOrderIndex = index
        this.currentOrder = cloneDeep(this.defaultValue)
        this.$set(this.currentOrder, 'is_temp', this.containerOrders.is_temp)
      } else {
        this.addOrderIndex = index
        this.currentOrder = cloneDeep(this.childrenOrders[index])
      }
      this.statusDialogVisible = true
    },
    /**
     * @description 退款（from drawer/櫃檯管理）
     * notice: currentOrder是單一訂單
     */
    editOpenRefund(index) {
      try {
        if (index === 'main') {
          this.addOrderIndex = index
          this.currentOrder = this.orderType === 'goods' ? cloneDeep(this.containerOrders) : cloneDeep(this.defaultValue)
        } else {
          this.addOrderIndex = index
          if (this.showAllStatus) {
            this.currentOrder = cloneDeep(this.containerOrders['childrenOrderContainers']['items'][index]['orders'][0])
          } else {
            this.currentOrder = cloneDeep(this.childrenOrders[index])
          }
        }
        this.refundSubmitData = {
          refundDate: formatDate(new Date(), 'date-dash'),
          amount: this.currentOrder.recommendRefundValue.amount,
          note: '',
          paymentMethod: '',
          bonus: this.currentOrder.recommendRefundValue.bonus,
        }
        this.orderRefundShow = true
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 將activeName複製起來，並且讓activeName為空（無狀態）
     */
    cloneActiveNameFunc() {
      this.cloneActiveName = this.activeName
      this.activeName = '-1'
    },
    /**
     * @description 開啟[+ 新增子訂單]
     */
    async openAddOrder() {
      try {
        this.cloneActiveNameFunc()
        const checkHasUnpaidOrder = () => {
          const isUnPaid = this.defaultValue.paymentStatus === 'UNPAID'
          const isChildrenUnPaid = this.childrenOrders.some((item) => {
            return item.paymentStatus === 'UNPAID' && item.status !== 0
          })
          const isParentContainerTemp = this.containerOrders.is_temp === 1
          // 這個母訂單為未付款 || 這個母訂單的子訂單是否有未付款 || 父容器為卡單狀態
          if (isUnPaid || isChildrenUnPaid || isParentContainerTemp) {
            this.$confirm('未付款前，加購請於原來的訂單中選擇『編輯價格與折扣』 ', '提醒', {
              confirmButtonText: '確定',
              showCancelButton: false,
              type: 'warning',
              center: true,
            })
            this.activeName = this.cloneActiveName
            return true
          }
          if (this.childrenContainerUnpaidAndTemp) {
            this.$confirm('請先將其他子訂單付款完成，再進行新增子訂單 ', '提醒', {
              confirmButtonText: '確定',
              showCancelButton: false,
              type: 'warning',
              center: true,
            })
            this.activeName = this.cloneActiveName
            return true
          }
          return false
        }
        if (!checkHasUnpaidOrder()) {
          this.childrenSubmitData.params = []
          this.totalAllShow = true
          this.visibleAdditionForm = true
          this.isChildrenOrderCreating = true
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 顯示選擇發送方式Dialog
     */
    showShareDialog() {
      this.shareDialogVisible = true
    },
    closeNotificationDialog() {
      this.writeDialogVisible = false
    },
    async tryToGetShareLink() {
      this.shareLink = await this.$store.dispatch('order/getLink', this.defaultValue.id)
    },
    handleShareLink(platform) {
      const platformLinkMap = {
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${this.shareLink}`,
        line: `https://social-plugins.line.me/lineit/share?url=${this.shareLink}`,
      }
      window.open(platformLinkMap[platform], '_blank')
    },
    /**
     * @description 發送簡訊
     */
    async tryToSendSMS() {
      this.tryingSendSMS = true
      try {
        await this.$store.dispatch('order/sendContainerLink', {
          uuid: this.containerOrders.uuid,
          router: 'sms',
        })
        this.$alert(`已發送${this.linkTitle}連結簡訊至使用人電話`, '簡訊發送成功！', {
          confirmButtonText: '確認',
          center: true,
          callback: () => {
            this.tryingSendSMS = false
          },
        })
      } catch (error) {
        this.tryingSendSMS = false
      }
    },
    async copyShareLink() {
      const ghostInput = document.createElement('INPUT')
      document.body.appendChild(ghostInput)
      ghostInput.setAttribute('value', this.shareLink)
      ghostInput.select()
      document.execCommand('copy')
      document.body.removeChild(ghostInput)

      if (process.env.VUE_APP_BUILD_MODE === 'admin-app-build') {
        await Clipboard.write({
          string: this.shareLink,
        })
      }

      this.$message('連結複製成功')
    },
    /**
     * @description 報到狀態 -> 改成已報到
     */
    showCheckinStatusDialog() {
      this.checkinStatusDialogVisible = true
    },
    /**
     * @description 確認將此訂單改為「已報到」-> 開啟
     */
    checkinStatusDialogV2Open() {
      this.checkinStatusDialogVisibleV2 = true
    },
    /**
     * @description 確認將此訂單改為「已報到」-> 關閉
     */
    checkinStatusDialogV2Close() {
      this.checkinStatusDialogVisibleV2 = false
    },
    /**
     * @description 超時計算Dialog -> 開啟
     */
    async overTimeCalDialog(item) {
      await this.seeOrder(item)
      this.checkedItem = [item] // 把資料傳給待報到
      this.showCheckinStatusDialog()
    },
    /**
     * @description 超時計算Dialog -> 關閉
     */
    overTimeCalDialogClose() {
      this.overTimeStatusCalDialog = false
    },
    paidConfirm() {
      const paymentMethod = this.paidConfirmValue.paymentMethod
      this.tryToPayOrder(paymentMethod, this.paidConfirmValue)
    },
    /**
     * @description 開啟付款視窗
     */
    openPaidDialog() {
      this.isDialogPaidConfirmVisible = true
      this.paidConfirmValue = this.submitData
    },
    openAddPaidDialog() {
      this.isDialogPaidConfirmVisible = true
      this.paidConfirmValue = this.unPaidAddOrder
    },
    async tryToPayOrder(method, data) {
      try {
        const { params, ...other } = data
        this.tryingPayOrder = true
        await this.$store.dispatch('order/store', {
          ...other,
          paymentMethod: method,
          paymentStatus: 'PAID',
        })
        this.$message({
          type: 'success',
          message: '編輯成功！',
        })
        await this.updateOrder()
        this.paidDialogVisible = false
      } finally {
        this.tryingPayOrder = false
      }
    },
    /**
     * @description 從其他地方來做「前往付款包月訂單」
     */
    goPayForPrepaid(orderDetail) {
      try {
        this.goToPrepaidOrder(orderDetail['prepaidOrderUuid'])
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 前往付款包月訂單（vue router 跳轉頁面）
     * @param {*} id prepaidOrderUuid
     */
    goToPrepaidOrder(id) {
      this.$router.push({
        name: 'orders',
        query: {
          type: 'prepaidOrder',
          id,
        },
      })
    },
    async onClickNoShow() {
      await this.$refs.form.validate()
      await this.$confirm('確定將此訂單改為「未報到」？', '警告', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      })
      this.tryingNoShow = true
      const { params, ...other } = this.defaultValue
      const storeData = {
        ...other,
        status: 5,
        merchantNote: this.submitData.note,
      }
      try {
        await this.$store.dispatch('order/store', storeData)
        await this.updateOrder()
        this.submitData.note = ''
        this.noShowDialogVisible = false
        this.checkinStatusDialogVisible = false
        await this.openDrawerSchedule()
      } finally {
        this.tryingNoShow = false
      }
    },
    /**
     * @description 報到＋分配助理
     */
    async tryToStoreAssignAndCheckIn() {
      try {
        // 上傳美容契約簽名圖片
        await this.uploadSalonSignature()
        await this.updateOrder()
        console.log(this.defaultValue)
        this.tryingCheckIn = true
        await this.tryToCheckIn()
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 將未報到改成已報到
     */
    async tryToCheckIn() {
      await this.$refs.beauticianForm.validate()
      this.checkDialogVisible = false
      try {
        this.tryingCheckIn = true
        await this.$store.dispatch('order/verifySingleCode', {
          codeId: this.reservationItem.codes[0].id,
          orderId: this.defaultValue.id,
        })
        this.$message({
          type: 'success',
          message: '報到成功！',
        })
        this.checkinStatusDialogVisible = false
        await this.updateOrder()
      } finally {
        this.tryingCheckIn = false
        await this.openDrawerSchedule()
      }
    },
    /**
     * @description [簽名確認btn]，開啟簽名確認component
     */
    async showSignDialog(item) {
      await this.seeOrder(item)
      this.startTab = 2
      this.signDialogKey++
      this.signDialogVisible = true
    },
    /**
     * @description 加購之後的確認修改
     */
    async tryToStoreOrderItem() {
      const isBeforeExpired = this.memberInfo.level.expiredAt === null || new Date() <= new Date(formatGetTime(this.memberInfo.level.expiredAt))
      if (!isBeforeExpired) return this.errorCurrentMemberLevel()

      if (this.submitPriceTotal < 0) {
        this.$confirm('訂單金額不能小於0', '提醒', {
          confirmButtonText: '確定',
          showCancelButton: false,
          type: 'warning',
          center: true,
        })
        return
      }
      let cloneParams = cloneDeep(this.currentOrder.params)
      cloneParams = cloneParams.filter((item) => item.priceId !== 'fake') // 因為要讓價錢算的一樣，所以要塞入fake總價，但到這邊要filter掉
      let couponCode
      if (this.isMainOrder) {
        if (this.deleteCoupon.id) {
          this.deleteIds = [this.deleteCoupon.id, ...this.deleteIds]
        }
      }

      if (this.isMainOrder && this.hasCouponInfo) {
        if (this.submitData.couponCode !== this.couponItem.code) couponCode = this.submitData.couponCode
      }

      const data = {
        adds: cloneParams.filter(({ id }) => id === undefined),
        couponCode,
        orderId: this.currentOrder.id,
        deleteIds: this.deleteIds,
        total: this.submitPriceTotal,
      }
      this.tryingStoreOrderItem = true
      try {
        await this.$store.dispatch('order/storeOrderItem', data)
        this.$message({
          type: 'success',
          message: '編輯成功！',
        })
        this.couponInfo = {}
        this.deleteIds = []
        this.deleteCoupon = {}
        await this.updateOrder()
        this.cancelToTalEdit({ resetCoupon: false })
        await this.openDrawerSchedule()
        this.visibleAdditionForm = false
      } finally {
        this.tryingStoreOrderItem = false
      }
    },
    async tryToSaveOrder(type) {
      const { params, ...other } = this.currentOrder
      let storeData = {}

      if (type === 'extraField') {
        storeData = {
          ...this.convertExtraFieldToStoreDataFromEditMode({
            ...other,
          }),
          merchantNote: '',
        }
      } else {
        storeData = {
          ...other,
          merchantNote: '',
        }
      }

      if (this.currentOrder.paymentMethod === 'Deposit') storeData.paymentStatus = 'PAID'

      this.tryingStore = true
      try {
        await this.$store.dispatch('order/store', storeData)
        this.handleSaveSuccess()
        await this.updateOrder()
        // 很多地方都會用到編輯訂單，所以必須關掉很多的介面
        this.noteEditShow = false
        this.editPaymentMethodShow = false
        this.addressShow = false
      } catch (error) {
        this.$message({
          type: 'error',
          message: `Server Error`,
        })
      } finally {
        this.tryingStore = false
      }
    },
    handleSaveSuccess() {
      this.$message({
        message: '編輯成功！',
        type: 'success',
      })
    },
    /**
     * @description 更新訂單
     */
    async updateOrder() {
      try {
        const updatedValue = await this.$store.dispatch('order/fetchSingle', this.defaultValue.id)
        this.$emit('update:defaultValue', updatedValue)
        this.submitData = cloneDeep(updatedValue)
        this.updateCoupon()
        this.$emit('update')
      } catch (error) {
        console.error(error.message)
      }
    },
    errorCurrentMemberLevel() {
      this.$alert(`超過會員等級方案"${this.memberInfo.level.title}"截止時間，請重新下單`, {
        title: `提示`,
        showClose: false,
        dangerouslyUseHTMLString: true,
      })
        .then(() => {
          this.tryToFetchDetail(this.memberInfo.id)
          this.closeChildren()
          this.cancelToTalEdit()
        })
        .finally(() => {
          this.tryingStoreOrderItem = false
        })
    },
    convertExtraFieldToStoreDataFromEditMode(submitData) {
      const orderInfo = cloneDeep(submitData)
      const getExtraFieldsArray = (extraFields) => {
        const extraFieldsArray = []
        const isEdited = (field) => {
          return field.edited === true
        }
        Object.keys(extraFields).forEach((extraFieldsId) => {
          if (isEdited(extraFields[extraFieldsId])) {
            const { id, value } = extraFields[extraFieldsId]
            extraFieldsArray.push({
              id,
              value,
            })
          }
        })
        return extraFieldsArray
      }
      const getBySizeExtraFieldsArray = (customerInfos) => {
        return customerInfos.map((customerInfo) => {
          return {
            customerInfoId: customerInfo.customerInfoId,
            orderExtrafields: getExtraFieldsArray(customerInfo.bySizeExtrafields),
          }
        })
      }
      if (orderInfo.byOrderExtrafields) orderInfo.byOrderExtrafields = getExtraFieldsArray(orderInfo.byOrderExtrafields)
      if (orderInfo.customerInfos) orderInfo.bySizeExtrafields = getBySizeExtraFieldsArray(orderInfo.customerInfos)

      if (orderInfo.customerInfos) delete orderInfo.customerInfos
      return orderInfo
    },
    /**
     * @description 按下新增子訂單
     */
    closeChildren() {
      try {
        this.cancelToTalEdit({ resetCoupon: false })
        this.visibleAdditionForm = false
        this.isChildrenOrderCreating = false
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description basePrice 是所有正數加起來
     */
    updateBasePrice(isChildrenOrder = false) {
      try {
        if (isChildrenOrder) {
          let basePrice = 0
          if (this.isChildrenOrderCreating) {
            basePrice = calcBasePrice({ price: basePrice, totalEditList: this.childrenSubmitData.params })
          }
          this.basePrice = basePrice
        } else {
          let basePrice = !this.isMainOrder ? 0 : this.reservationTotal
          basePrice = calcBasePrice({ price: basePrice, totalEditList: this.currentOrder.params })
          this.basePrice = basePrice
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    async tryToStorePayment() {
      if (this.currentOrder.paymentMethod === 'Deposit') {
        if (this.reservationItem.canPayByDeposit === false) {
          await this.$confirm(`${this.hasCannotPayByDepositAddition ? '加購項目中某幾項' : '此方案'}未設定可使用儲值點數抵扣，請問是否確定抵扣 ${this.currentOrder.priceTotal} 點？`, '抵扣未開放', {
            confirmButtonText: '確定',
            type: 'warning',
            center: true,
          })
        } else {
          await this.$confirm(`確定要使用儲值金抵扣 ${this.paidAndUnPaidSummary.unPaid} 點？`, '提醒', {
            confirmButtonText: '確定',
            type: 'warning',
            center: true,
          })
        }
        if (this.depositReduce < this.paidAndUnPaidSummary.unPaid) {
          await this.$confirm(`儲值金餘額不足，是否加值`, '提醒', {
            confirmButtonText: '確定',
            type: 'warning',
            center: true,
          })
          this.createDepositOrderVisible = true
          return
        }
      }
      await this.saveContainerPaymentMethod()
    },
    /**
     * @description 變更付款方式(去打containerStore)
     */
    async saveContainerPaymentMethod() {
      let fetchId = this.testUnpaidContainer.parentUuid.length > 0 ? this.testUnpaidContainer.parentUuid : this.testUnpaidContainer.childUuid
      const containerInfo = await this.$store.dispatch('order/fetchContainerList', fetchId)
      const result = await this.$store.dispatch('order/storeContainerId', {
        allowExpired: containerInfo.allowExpired,
        email: containerInfo.email ?? '',
        fullName: containerInfo.fullName,
        gender: containerInfo.gender,
        note: containerInfo.note ?? '',
        paymentMethod: this.currentOrder.paymentMethod,
        paymentStatus: this.currentOrder.paymentMethod === 'Deposit' ? 'PAID' : containerInfo.paymentStatus,
        phoneCode: containerInfo.phoneCode,
        phoneNumber: containerInfo.phoneNumber,
        total: this.paidAndUnPaidSummary.unPaid,
        uuid: containerInfo.uuid,
      })

      if (result.code === 200) {
        this.$message({
          type: 'success',
          message: '儲存成功',
        })
        this.editPaymentMethodShow = false
        await this.openDrawerSchedule()
        await this.$emit('update')
      }
    },
    /************ 編輯客戶資訊相關 start ************/
    closeEditMemberForm() {
      this.editDetailEnabled = false
    },
    /**
     * @description fetch 單筆會員資訊
     */
    async tryToFetchDetail(memberId) {
      try {
        this.memberInfo = await this.$store.dispatch('member/fetchSingle', { memberId })
        this.closeEditMemberForm()
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 取得containerUUid && 得到container訂單
     */
    async getContainerUuid() {
      try {
        const { orderContainerUuid } = this.defaultValue
        this.containerOrders = await this.$store.dispatch('order/fetchContainerList', orderContainerUuid)
        await this.getCosmeticBasicToSetTempTime()
        this.orderContainerUuid = orderContainerUuid
        this.computedOrderOverTime()
      } catch (error) {
        console.error(error.message)
      }
    },
    /************ 編輯客戶資訊相關 end ************/

    /************ 客戶資訊相關 start ************/
    closeMemberInfo() {
      this.memberInfoShow = false
      this.scrollTo(this.$refs.leftCont)
    },
    /************ 客戶資訊相關 end ************/

    /************ 編輯備註相關 start ************/
    async tryToStoreNote(data) {
      this.currentOrder = data
      this.tryToSaveOrder('extraField')
      this.containerOrders = await this.$store.dispatch('order/fetchContainerList', this.defaultValue.orderContainerUuid)
    },
    /************ 編輯備註相關 end ************/

    /************ 變更付款方式相關 start ************/
    onUpdatePayment(data) {
      const { allowExpired, paymentMethod, Card4No, PayerAccount5Code, bankType } = data
      this.currentOrder = {
        ...this.currentOrder,
        allowExpired,
        paymentMethod,
        Card4No,
        PayerAccount5Code,
        bankType,
      }
      this.tryToStorePayment()
    },
    closeEditPaymentMethod() {
      this.editPaymentMethodShow = false
    },
    /************ 變更付款方式相關 end ************/

    /************ 助理相關 start ************/
    async tryToFetchHelperList(isSpace) {
      try {
        await this.mixinTryToFetchHelperList(this.defaultValue, isSpace)
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 分配助理後儲存
     */
    async tryToStoreAssignHelper({ isSpace }) {
      try {
        this.tryingAssign = true
        if (isSpace === 0) {
          await this.mixinSyncAssignHelpers(this.defaultValue, this.submitData)
        } else {
          const { action, itemId } = this.decideActionStatus(isSpace, this.defaultValue, this.submitData)
          if (action === 'remove-add') {
            await this.storeAssignHelperApiForRemoveAdd(this.defaultValue, itemId)
          }
          if (action === 'remove') {
            await this.storeAssignHelperApi('remove', itemId, isSpace)
          }
          if (action === 'add') {
            await this.storeAssignHelperApi('add', itemId, isSpace)
          }
        }
        await this.updateOrder() // 要更新訂單 改這個等於是改訂單
        await this.getContainerUuid()
        await this.initTab() // 初始化tab
      } catch (error) {
        console.error(error.message)
      } finally {
        this.tryingAssign = false
      }
    },

    /**
     * @description 助理/空間的儲存api
     */
    async storeAssignHelperApi(action, saveId = '', isSpace) {
      try {
        await this.mixinStoreAssignHelperApi(action, saveId, isSpace, this.defaultValue, this.submitData)
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 開啟助理編輯
     */
    async openAssignEdit(index, item, type) {
      try {
        console.log(index, item, type)
        this.tryingAssign = true
        this.openCloseAssistType(type, true)
        await this.seeOrder(item)
        this.openAssistSelect(index, type)
        this.initHelper()
      } catch (error) {
        console.error(error.message)
      } finally {
        this.tryingAssign = false
      }
    },
    initHelper() {
      if (this.defaultValue.helper) {
        this.submitData.helper = {
          ...this.defaultValue.helper,
        }
      } else {
        this.submitData.helper = {
          id: '',
          name: '',
        }
      }
    },
    /************ 助理相關 end ************/

    /************ 寵物資訊相關 start ************/
    openCommentEdit() {
      this.$refs.comment.openEdit()
    },
    async tryToFetchCommentListAll() {
      if (this.petShow && this.petInfoActiveTab === 'currentService') {
        this.$refs.petList.$refs.commentAll2.tryToFetchList()
      } else {
        this.petShow = true
        this.petInfoActiveTab = 'currentService'
      }
    },
    emitCommentFetch() {
      this.tryToFetchCommentListAll()
    },
    /**
     * @description drawer -> 開啟寵物資訊
     */
    goToPetInfoDetail(val) {
      this.closeAllInfo()
      // 新增服務紀錄
      if (val.alias === 'addService') {
        this.openCommentEdit()
      } else {
        this.petShow = true
        this.petInfoActiveTab = val.alias
        this.isShowPetList = val.isShowPetList
      }
      // this.scrollTo(this.$refs.rightCont)
    },
    closePet() {
      this.petShow = false
      this.serviceType = ''
      this.isShowPetList = false
      this.scrollTo(this.$refs.leftCont)
    },
    /************ 寵物資訊相關 end ************/

    /************ 服務備註相關 start ************/
    openNoteEdit() {
      this.noteEditShow = true
      this.editPaymentMethodShow = false
      this.orderHistoryShow = false
      this.orderRefundShow = false

      this.memberInfoShow = false
      this.addressShow = false
    },
    closeNoteEdit() {
      this.noteEditShow = false
    },
    /************ 服務備註相關 end ************/

    /************ 加購相關 start ************/
    /**
     * @description 按下加購列表的加購之後，資料丟回來detail
     */
    onSubmitAddition(list) {
      try {
        const formattedList = list.map((item) => ({
          type: 'cosmetic-add',
          title: item.title,
          priceId: item.thisOrderServiceId,
          price: item.price,
          qty: item.qty,
        }))

        if (this.isChildrenOrderCreating) {
          this.childrenSubmitData.params.push(...formattedList)
        } else {
          this.currentOrder.params.push(...formattedList)
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    /************ 加購相關 end ************/

    /************ 變價相關 start ************/
    onSubmitTotalEdit(item) {
      if (this.isChildrenOrderCreating) this.childrenSubmitData.params.push({ ...item })
      else this.currentOrder.params.push({ ...item })
    },
    clearParams() {
      if (this.isChildrenOrderCreating) this.childrenSubmitData.params = []
      else this.currentOrder.params = this.currentOrder.params.filter(({ type }) => !['cosmetic-add', '+', '-', '%', 'express'].includes(type))
    },
    /************ 變價相關 end ************/

    onUpdateTotalStatement({ params, deleteIds }) {
      this.clearParams()
      if (this.isChildrenOrderCreating) this.childrenSubmitData.params = [...params]
      else this.currentOrder.params = [...this.currentOrder.params, ...params]
      this.deleteIds = [...deleteIds]
    },
    /**
     * @description 客戶資訊baseCollapse
     * 點擊會員資訊/消費紀錄/客戶備註打上來都在這邊
     */
    goToMemberInfoDetail(val) {
      try {
        this.closeAllInfo()
        this.memberInfoShow = true
        this.memberInfoActiveTab = val
      } catch (error) {
        console.error(error.message)
      }
    },
    /****** 客戶資訊 end ******/
    hasPrepaidParams(params) {
      return params.some((item) => {
        return item.type === 'prepaid'
      })
    },
    scrollTo(el) {
      this.$nextTick(() => {
        if (!el) return
        scrollToElement(el, 100)
      })
    },
    handlePayButton() {
      if (this.computedFreeService && this.thisParentContainerHasPaid) {
        this.completeReserveAndPay()
        return
      }

      if (!this.thisParentContainerHasPaid) {
        if (this.containerOrders.paymentMethod === 'Installment') {
          this.checkResultAndPay()
        } else {
          this.completeReserveAndPay()
        }
        return
      }

      if (!this.thisChildContainerHasPaid) {
        this.completeReserveAndPay()
      }
    },
    async fetchMerchantSetting() {
      try {
        const { response } = await this.getCosmeticBasicSet({ type: 'cosmetic' })
        return response
      } catch (error) {
        console.error('fetchMerchantSetting error:', error)
        this.$message.error('取得設定失敗，請稍後再試')
        return null
      }
    },
    async onClickCheckIn() {
      try {
        const merchantSettingResponse = await this.fetchMerchantSetting()
        if (merchantSettingResponse) {
          this.merchantSettingData = merchantSettingResponse
        }
      } catch (error) {
        console.error('onClickCheckIn error:', error)
        this.$message.error('載入設定失敗')
      }
      this.checkDialogSupplementMode = false
      this.salonSignatureFile = null
      this.checkDialogVisible = true
    },
    async openSalonContractSupplement() {
      try {
        const merchantSettingResponse = await this.fetchMerchantSetting()
        if (merchantSettingResponse) {
          this.merchantSettingData = merchantSettingResponse
        }
      } catch (error) {
        console.error('openSalonContractSupplement error:', error)
        this.$message.error('載入設定失敗')
        return
      }
      this.salonTermsAgree = true
      this.salonSignatureFile = null
      this.checkDialogSupplementMode = true
      this.checkDialogVisible = true
    },
    onSalonContractDialogClose() {
      this.checkDialogSupplementMode = false
      this.salonSignatureFile = null
    },
    async fetchPetData() {
      try {
        const response = await this.fetchSinglePet({ memberId: this.memberInfo.id, petId: this.defaultValue.pet.id })
        return response.items
      } catch (error) {
        console.error(error)
      }
    },
    async fetchSingleStore() {
      try {
        const response = await this.fetchSingle(this.defaultValue.productId)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    async onClickPrint() {
      const petInfo = await this.fetchPetData()
      const storeInfo = await this.fetchSingleStore()

      this.printHtml = formatContract(this.defaultValue, this.memberInfo, petInfo, this.merchantSettingData, storeInfo, this.containerOrders.installments)

      this.$nextTick(() => this.$refs.printer.print())
    },
    async onSalonSignatureSaved(file) {
      this.salonSignatureFile = file
      if (!this.checkDialogSupplementMode) return

      try {
        await this.uploadSalonSignature()
        await this.updateOrder()
        this.salonSignatureFile = null
        this.$message.success('簽名已儲存')
      } catch (error) {
        console.error(error.message)
      }
    },
    async uploadSalonSignature() {
      if (!this.salonSignatureFile) return

      try {
        const salonSignImgURL = await this.$store.dispatch('merchant/uploadMerchantMedia', this.salonSignatureFile)

        const storeData = {
          ...this.defaultValue,
          service_contract_signature: salonSignImgURL,
          // status:6 ? 原先的簽名有 是否要加任何 status
          //TODO: 這邊要不要加 status?
        }
        await this.$store.dispatch('order/store', storeData)
      } catch (error) {
        console.log(error.message)
        this.$message({
          type: 'error',
          message: '簽名圖片上傳失敗 請重新簽名上傳',
        })
      }
    },
    ...mapActions('merchant', ['getCosmeticBasicSet']),
    ...mapActions('member', ['fetchSinglePet']),
    ...mapActions('product', ['fetchSingle']),
  },
}
</script>
<template>
  <div v-loading="allPageLoading" :class="$style.orderformSection">
    <div v-if="!totalAllShow && !checkResultAndPayStatus" class="orderformSection__all">
      <div v-if="!completeReserveAndPayStatus" class="orderformSection__left">
        <div :id="orderHeaderId" :class="$style.header" class="d-md-flex">
          <div>
            <h5 class="Jost">
              <BaseStateLabel round class="is-border d-md-none d-inline-block mb-2" :state="defaultValue.status | bookingStatusFilter('color')" text>{{
                defaultValue.status | bookingStatusFilter('text')
              }}</BaseStateLabel>
              <BaseStateLabel round :state="defaultValue.paymentStatus | paymentStatusMapFilter('color')" class="is-border d-md-none d-inline-block mb-2">{{
                defaultValue.paymentStatus | paymentStatusMapFilter('text')
              }}</BaseStateLabel>
              <br class=" d-md-none d-inline-block" />
            </h5>
            <h5 v-if="containerOrders.is_temp === 0" class="Jost" :class="$style.title">總訂單成立時間：{{ containerOrders.created_at }}</h5>
            <h5 class="Jost" :class="$style.title">服務地點：{{ defaultValue.productName }}</h5>
          </div>
        </div>

        <div ref="leftCont" class="orderformSection__left__content" :style="`height:calc(100vh - ${headerHeight}px)`">
          <div element-loading-background="rgba(0, 0, 0,0)" style="min-height: 300px; padding-top: 20px" class="info-section">
            <div class="orderformSection__left__content__time">
              <!-- 客戶資訊 -->
              <p v-if="Object.keys(containerOrders).length > 0 && containerOrders.is_temp === 1" class="orderformSection__left__content__timeMain">
                <span>
                  <BaseIcon name="clock" icon-style="fal" :class="[$style['header-icon-left'], 'fs-2xl', 'mr-3', 'align-text-bottom']" />
                </span>
                {{ `${minutes}:${seconds}` }}
              </p>
            </div>
            <BaseCollapse expanded is-order :order-theme="true" arrow-style="far">
              <template v-slot:title>
                <span>
                  <BaseIcon icon-style="fal" name="address-card" :class="[$style['header-icon-left'], 'fs-2xl', 'mr-3', 'align-text-bottom']" />
                  客戶資訊
                </span>
              </template>
              <OrderMemberInfo :member-info="memberInfo" @toDetail="goToMemberInfoDetail" />
            </BaseCollapse>
            <el-tabs v-if="isMixinOrders" v-model="tabActive" stretch class="mb-4">
              <el-tab-pane label="預約訂單" name="reservationOrder"></el-tab-pane>
              <el-tab-pane label="商品訂單" name="goodsOrder"></el-tab-pane>
            </el-tabs>
            <!-- 左側的選擇寵物列表 -->
            <LeftPetTab
              v-if="!totalAllShow && detailTypeCheck !== 'goods'"
              :active-name="activeName"
              :show-all="true"
              :service-count-by-pet="serviceCountByPet"
              :container-group-pet-id="containerGroupPetIdForDetail"
              :show-add="false"
              @updateActiveName="updateActiveNameForDetail"
              @handleClickPetTab="handleClickPetTabForDetail"
            />

            <!-- 左側寵物資訊 -->
            <BaseCollapse v-if="detailTypeCheck !== 'goods'" :expanded="activeName === ''" is-order :order-theme="true">
              <template v-slot:title>
                <span>
                  <BaseIcon v-if="$merchantI18n() === 'pet'" icon-style="fal" name="bone" :class="[$style['header-icon-left'], 'fs-lg', 'mr-3']" style="transform: rotate(-45deg)" />{{
                    $t('reserve.CLIENT')
                  }}資訊
                </span>
              </template>
              <OrderPetInfo :default-value="defaultValue" :pet-list="petList" :member-info="memberInfo" is-order-detail @toDetail="goToPetInfoDetail" />
              <PetCommentList ref="comment" type="order" class="d-none" :order="defaultValue" @emitFetch="emitCommentFetch" />
            </BaseCollapse>
            <!-- 服務項目 -->
            <BaseCollapse v-if="detailTypeCheck !== 'goods'" expanded is-order :order-theme="true">
              <template v-slot:title>
                <span> <BaseIcon v-if="$merchantI18n() === 'pet'" name="cut" /> 服務項目 </span>
              </template>
              <div v-for="(item, index) in petServiceGroupList" :key="index" v-loading="tryingAssign" :class="$style.serviceCollapse">
                <div class="d-flex align-items-center text-secondary" :class="$style.serviceCollapse__title">
                  <div v-if="hasPrepaidParams(item.orderDetail.params)" class="info-icon isPrepaid">
                    方案抵扣
                  </div>
                  <div v-else class="info-icon">
                    單次預約
                  </div>
                  <span style="width: 50%;">{{ item.contTitle }}</span>
                  <p v-if="activeName !== ''" @click="seeOrder(item, '', index)">
                    <span> <BaseIcon name="edit" class="text-primary" /> </span>查看訂單
                  </p>
                </div>
                <div :class="$style.serviceCollapse__context">
                  <div :class="$style.serviceCollapse__context__info">
                    <p
                      >{{ item.date }} {{ item.time }} <span style="display:none;">{{ item.orderId }}</span></p
                    >
                    <BaseStateLabel
                      v-if="item.orderDetail.status !== 3"
                      :round="true"
                      class="is-border d-md-inline d-none align-text-top"
                      :class="$style.serviceCollapse__context__info__label"
                      :state="item.orderDetail.status | bookingStatusFilter('color')"
                      text
                      >{{ item.orderDetail.status | bookingStatusFilter('text') }}</BaseStateLabel
                    >
                  </div>
                  <div :class="$style.serviceCollapse__detail">
                    <div :class="$style.serviceCollapse__member">
                      <div style="height: 60px;margin-bottom:0;display:flex;align-items: center;">
                        <p
                          >服務人員：<span> {{ item.name }}</span></p
                        >
                      </div>

                      <template v-if="item.orderDetail.status !== 0">
                        <div v-if="item.orderDetail.status === 6" :class="$style.editOneLine" style="height: 60px">
                          <h5 class="editOneLine__title">
                            助理：
                            <el-tooltip content="最多可指派 3 位助理，將用於分潤計算。" placement="top">
                              <BaseIcon name="info-circle" class="text-text-light" />
                            </el-tooltip>
                          </h5>
                          <span class="editOneLine__text">{{ helperWords(item, 'helpers') }} </span>
                        </div>

                        <div v-else element-loading-background="rgba(0, 0, 0,0)" :class="[$style.editOneLine, $style.editOneLineAssistant]">
                          <!-- 助理title -->
                          <h5 class="editOneLine__title">
                            助理：
                            <el-tooltip content="最多可指派 3 位助理，將用於分潤計算。" placement="top">
                              <BaseIcon name="info-circle" class="text-text-light" />
                            </el-tooltip>
                          </h5>
                          <!-- 助理下拉選單 => submitData.helpers.length > 0 是因為要晚點渲染-->
                          <HelperSelectOption item-show-key="editAssistantEnabled" :item="item" :submit-data.sync="submitData" submit-data-key="helpers" :assign-list="assignList" />
                          <HelperForShow item-show-key="editAssistantEnabled" :item="item" show-key="helpers" />
                          <!-- 助理的編輯icon -->
                          <HelperIcon item-show-key="editAssistantEnabled" :item="item" :active-name="activeName" :index="index" emit-type="prices" @openAssignEdit="openAssignEdit" />
                          <!-- 助理開啟編輯的儲存取消 -->
                          <HelperSaveCancelBtn
                            item-show-key="editAssistantEnabled"
                            cancel-type="prices"
                            :item="item"
                            :index="index"
                            :is-space="0"
                            @cancelAssignEdit="cancelAssignEdit"
                            @tryToStoreAssignHelper="tryToStoreAssignHelper"
                          />
                        </div>
                      </template>

                      <template v-if="item.orderDetail.status !== 0 && $hasSpaceModule()">
                        <div v-if="item.orderDetail.status === 6" :class="$style.editOneLine" style="padding:0  20px; height: 60px">
                          <h5 class="editOneLine__title">空間：</h5>
                          <span class="editOneLine__text"> {{ helperWords(item, 'spaceHelpers') }} </span>
                        </div>

                        <div v-else element-loading-background="rgba(0, 0, 0,0)" :class="$style.editOneLine" style="height: 60px">
                          <!-- 空間title -->
                          <h5 class="editOneLine__title">空間：</h5>
                          <!-- 空間下拉選單 -->
                          <HelperSelectOption item-show-key="editSpaceEnabled" :item="item" :submit-data.sync="submitData" submit-data-key="spaceHelpers" :assign-list="assignList" />
                          <!-- 沒有下拉時候的顯示 -->
                          <HelperForShow item-show-key="editSpaceEnabled" :item="item" show-key="spaceHelpers" />
                          <!-- 空間的icon -->
                          <HelperIcon item-show-key="editSpaceEnabled" :item="item" :active-name="activeName" :index="index" emit-type="space" @openAssignEdit="openAssignEdit" />
                          <!-- 空間開啟編輯的儲存取消 -->
                          <HelperSaveCancelBtn
                            item-show-key="editSpaceEnabled"
                            cancel-type="spaces"
                            :item="item"
                            :index="index"
                            :is-space="1"
                            @cancelAssignEdit="cancelAssignEdit"
                            @tryToStoreAssignHelper="tryToStoreAssignHelper"
                          />
                        </div>
                      </template>

                      <template>
                        <div element-loading-background="rgba(0, 0, 0, 0)" :class="$style.editOneLine" style="height: 60px">
                          <!-- 指定狀態title -->
                          <h5 class="editOneLine__title">指定狀態：</h5>
                          <!-- 指定狀態下拉選單 -->
                          <el-select v-if="item.orderDetail.specifyVisible" v-model="item.orderDetail.isSpecifyScheduleItem" style="width: 185px">
                            <el-option label="指定" :value="1"></el-option>
                            <el-option label="不指定" :value="0"></el-option>
                          </el-select>
                          <!-- 沒有下拉時候的顯示 -->
                          <template v-if="!item.orderDetail.specifyVisible">
                            <span class="editOneLine__text">{{ item.orderDetail.isSpecifyScheduleItem ? '指定' : '不指定' }}</span>
                          </template>
                          <!-- 指定狀態的icon -->
                          <el-button v-if="!item.orderDetail.specifyVisible" class="isPrimary" type="text" style="padding-top: 2px;" @click="openSpecifyFun(item.orderDetail)">
                            <BaseIcon name="edit" class="fs-xl" />
                          </el-button>
                          <!-- 指定狀態開啟編輯的儲存取消 -->
                          <template v-if="item.orderDetail.specifyVisible">
                            <el-button class="is-round" size="mini" style="margin-left: 16px;" @click="item.orderDetail.specifyVisible = false">
                              取消
                            </el-button>
                            <el-button class="is-round" type="primary" size="mini" @click="tryToStoreSpecify(item.orderDetail)">
                              儲存
                            </el-button>
                          </template>
                        </div>
                      </template>
                    </div>
                    <div v-if="activeName !== '' && containerOrders.is_temp === 0" :class="$style.serviceCollapse__btnGroup">
                      <el-button v-if="signaturBtnShow(item)" class="is-round" :class="$style.serviceCollapse__btnGroup__Sign" type="primary" @click="showSignDialog(item)">簽名確認</el-button>
                      <el-button
                        v-if="item.orderDetail.status === 3"
                        class="is-round"
                        type="primary"
                        :class="$style.serviceCollapse__btnGroup__btn"
                        :disabled="tryingStore"
                        :loading="tryingStore"
                        @click="overTimeCalDialog(item)"
                      >
                        待報到
                      </el-button>
                    </div>
                  </div>
                </div>
              </div>
            </BaseCollapse>

            <BaseCollapse v-if="detailTypeCheck === 'goods'" expanded is-order :order-theme="true">
              <template v-slot:title>
                <span> <BaseIcon v-if="$merchantI18n() === 'pet'" name="cut" /> 購買商品 </span>
              </template>
              <div v-for="item in currentSelectOrder[0].params" :key="item.spec_tag" class="d-flex justify-content-between align-items-center">
                <div v-if="item.type === 'goods'">
                  <h5>{{ item.title }}</h5>
                  <span v-for="(spec, index) in item.spec" :key="spec.alias"> {{ `${spec.title}:${spec.values[0].title}` }} <span v-if="index < item.spec.length - 1">|</span> </span>
                  <p>{{ `x${item.qty}` }}</p>
                </div>
                <p v-if="item.type === 'goods'" style="color: black; font-size: 18px;">{{ `$${item.price * item.qty}` }}</p>
              </div>
            </BaseCollapse>

            <!-- 到府專用地址 -->
            <template v-if="isHomeService">
              <BaseCollapse expanded is-order :order-theme="true" arrow-style="far">
                <template v-slot:title>
                  <span> <BaseIcon name="map-marker-alt" /> 服務地址 </span>
                </template>
                <div style="margin-bottom:30px">
                  <div v-if="defaultValue.city" style="margin-bottom:20px">服務地址：{{ defaultValue.city }}{{ defaultValue.district }}{{ defaultValue.address }}</div>
                  <el-button v-if="!defaultValue.city" type="text" style="padding-top: 0; text-decoration: underline" @click="openAddressEdit"> 新增服務地址 </el-button>
                  <el-button v-else type="text" style="padding-top: 0; text-decoration: underline" @click="openAddressEdit"> 編輯服務地址 </el-button>
                </div>
              </BaseCollapse>
            </template>
            <!-- 發票資訊 -->
            <template v-if="false || defaultValue.invoice.InvoiceNumber">
              <BaseCollapse is-order :order-theme="true" arrow-style="far">
                <template v-slot:title>
                  <span> 發票資訊</span>
                </template>
                <div style="margin-bottom:30px">
                  <div :class="$style.invoice">
                    <div style="margin-bottom:10px"> 預約訂單#{{ defaultValue.id }}</div>
                    <div class="info">
                      <el-row :gutter="20">
                        <el-col :span="12" :xs="24">
                          <div class="info-item">
                            <span class="title">發票日期</span>
                            <span>{{ defaultValue.invoice.CreateTime | formatDate }}</span>
                          </div>
                          <div class="info-item">
                            <span class="title">發票號碼</span>
                            <span>{{ defaultValue.invoice.InvoiceNumber }}</span>
                          </div>
                          <div class="info-item">
                            <span class="title">隨機碼</span>
                            <span>{{ defaultValue.invoice.RandomNum }}</span>
                          </div>
                        </el-col>
                        <el-col :span="12" :xs="24">
                          <div class="info-item">
                            <span class="title">發票形式</span>
                            <span>{{ taxTypeMap[defaultValue.invoice.taxType] }}</span>
                          </div>
                          <div v-if="defaultValue.invoice.taxType === 'B2C'" class="info-item">
                            <span class="title">載具類別</span>
                            <span>{{ carrierTypeMap[defaultValue.invoice.CarrierType] }}</span>
                          </div>
                          <div v-if="defaultValue.invoice.taxType === 'B2C' && ['0', '1'].includes(defaultValue.invoice.CarrierType)" :span="12" :xs="24" class="info-item">
                            <span class="title">載具編號</span>
                            <span>{{ defaultValue.invoice.CarrierNum }}</span>
                          </div>
                          <div v-if="defaultValue.invoice.taxType === 'B2B'" class="info-item">
                            <span class="title">統一編號</span>
                            <span>{{ defaultValue.invoice.taxId }}</span>
                          </div>
                          <div v-if="defaultValue.invoice.taxType === 'DONATE'" class="info-item">
                            <span class="title">捐贈碼</span>
                            <span>{{ defaultValue.invoice.LoveCode }}</span>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                  <template v-if="childrenOrdersHaveInvoice.length > 0">
                    <div v-for="addOrder in childrenOrdersHaveInvoice" :key="addOrder.invoice.InvoiceNumber" :class="$style.invoice">
                      <div style="margin-bottom:10px"> 子訂單#{{ addOrder.id }}</div>
                      <div class="info">
                        <el-row :gutter="20">
                          <el-col :span="12" :xs="24">
                            <div class="info-item">
                              <span class="title">發票日期</span>
                              <span>{{ addOrder.invoice.CreateTime | formatDate }}</span>
                            </div>
                            <div class="info-item">
                              <span class="title">發票號碼</span>
                              <span>{{ addOrder.invoice.InvoiceNumber }}</span>
                            </div>
                            <div class="info-item">
                              <span class="title">隨機碼</span>
                              <span>{{ addOrder.invoice.RandomNum }}</span>
                            </div>
                          </el-col>
                          <el-col :span="12" :xs="24">
                            <div class="info-item">
                              <span class="title">發票形式</span>
                              <span>{{ taxTypeMap[addOrder.invoice.taxType] }}</span>
                            </div>
                            <div v-if="addOrder.invoice.taxType === 'B2C'" class="info-item">
                              <span class="title">載具類別</span>
                              <span>{{ carrierTypeMap[addOrder.invoice.CarrierType] }}</span>
                            </div>
                            <div v-if="addOrder.invoice.taxType === 'B2C' && ['0', '1'].includes(addOrder.invoice.CarrierType)" :span="12" :xs="24" class="info-item">
                              <span class="title">載具編號</span>
                              <span>{{ addOrder.invoice.CarrierNum }}</span>
                            </div>
                            <div v-if="addOrder.invoice.taxType === 'B2B'" class="info-item">
                              <span class="title">統一編號</span>
                              <span>{{ addOrder.invoice.taxId }}</span>
                            </div>
                            <div v-if="addOrder.invoice.taxType === 'DONATE'" class="info-item">
                              <span class="title">捐贈碼</span>
                              <span>{{ addOrder.invoice.LoveCode }}</span>
                            </div>
                          </el-col>
                        </el-row>
                      </div>
                    </div>
                  </template>
                </div>
              </BaseCollapse>
            </template>
            <!-- 服務條款簽名 -->
            <div v-if="showServiceContractSignatureSection" :class="$style.serviceContractSection">
              <BaseCollapse expanded is-order :order-theme="true" arrow-style="far">
                <template v-slot:title>
                  <span> 服務條款簽名 </span>
                </template>
                <div>
                  <img
                    v-if="defaultValue.service_contract_signature"
                    :src="defaultValue.service_contract_signature"
                    alt="簽名圖片"
                    :class="$style.signaturePreview"
                  />
                  <div v-else :class="[$style.signaturePreview, $style.signaturePlaceholder]">尚未簽名</div>
                </div>
              </BaseCollapse>
              <el-button type="primary" class="is-round" :class="$style.serviceContractBtn" @click="openSalonContractSupplement">檢視服務條款 / 簽名</el-button>
            </div>
            <!-- 服務完成簽名 -->
            <BaseCollapse v-if="defaultValue.status === 6" is-order :order-theme="true" arrow-style="far">
              <template v-slot:title>
                <span> 服務完成簽名</span>
              </template>
              <div style="margin-bottom:20px">
                <el-image :src="defaultValue.signature" :class="$style.image">
                  <div slot="error"> 圖片載入失敗 </div>
                </el-image>
              </div>
            </BaseCollapse>
          </div>
        </div>
      </div>
      <!-- 抽屜的右半部分 -->
      <div v-if="!completeReserveAndPayStatus" ref="rightCont" class="orderformSection__right">
        <template>
          <!-- 客戶編輯 -->
          <template v-if="editDetailEnabled">
            <MemberForm :default-value="memberInfo" @update="tryToFetchDetail" @close="closeEditMemberForm" />
          </template>
          <!-- 客戶資訊 -->
          <template v-if="memberInfoShow && !editDetailEnabled">
            <MemberInfo :member-info="memberInfo" :member-info-active-tab="memberInfoActiveTab" @update="tryToFetchDetail" @close="closeMemberInfo" />
          </template>
          <!-- 寵物選擇 -->
          <template v-if="petShow">
            <PetList
              ref="petList"
              :default-value="defaultValue"
              :active-id="defaultValue.pet.id"
              :member-info="memberInfo"
              :pet-info-active-tab="petInfoActiveTab"
              :is-show-pet-list="isShowPetList"
              @close="closePet"
              @update="tryToFetchDetail(memberInfo.id)"
            />
          </template>
          <!-- 編輯到府地址 -->
          <template v-if="addressShow">
            <AddressForm :default-value="currentOrder" :loading="tryingStore" @update="saveHomeAddress" @close="closeAddress" />
          </template>
          <!-- 備註編輯 -->
          <template v-if="noteEditShow">
            <NoteForm :current-order="currentOrder" :member-info="memberInfo" :loading="tryingStore" @update="tryToStoreNote" @close="closeNoteEdit" />
          </template>
          <!-- 查看歷史紀錄 -->
          <template v-if="orderHistoryShow">
            <div class="orderformSection__right__header">
              <button class="el-drawer__close-btn" aria-label="close drawer" type="button" @click="closeHistory"><i class="el-dialog__close el-icon el-icon-close"></i></button>
              <h4 class="orderformSection__right__title">訂單變更記錄</h4>
            </div>
            <div class="orderformSection__right__content">
              <el-timeline>
                <el-timeline-item v-for="log in currentHistory" :key="log.id" :timestamp="log.created | formatDate('dateTime')" type="primary" placement="top">
                  {{ log.description }}
                  <span style="font-size: 13px">
                    <span v-if="log.creator">- {{ log.creator }}</span>
                  </span>
                  <div v-if="log.note">{{ log.note }}</div>
                </el-timeline-item>
              </el-timeline>
            </div>
          </template>

          <!-- 編輯付款方式 -->
          <template v-if="editPaymentMethodShow">
            <PaymentEditForm :current-order="currentOrder" :loading="tryingStore" @update="onUpdatePayment" @close="closeEditPaymentMethod" />
          </template>

          <!-- 尚未付款的包月 -->
          <template v-if="unPaidPrepaidPageStatus">
            <UnPaidPrepaidPage :container-orders="containerOrders" @goPayForPrepaid="goPayForPrepaid" @closeThisComp="unPaidPrepaidPageStatus = false" />
          </template>
        </template>
        <!-- 變價 -->
        <div v-if="!unPaidPrepaidPageStatus" :class="$style.total">
          <div class="total__cont">
            <TotalStatementDetail
              :order-type="detailTypeCheck"
              :container-orders="containerOrders"
              :show-service-all="activeName === ''"
              :default-value="currentSelectOrder[currentOrderIndex]"
              :member-info="memberInfo"
              :is-detail="true"
              @openAdd="openAddEdit"
              @editOpenTotalEdit="editOpenTotalEdit"
              @editOpenPaymentMethod="editOpenPaymentMethod"
              @editOpenHistory="editOpenHistory"
              @emitContainerId="emitContainerId"
              @tryToCancelOrder="tryToCancelOrder"
              @editOpenRefund="editOpenRefund"
              @noteEdit="openNoteEdit"
              @showAll="showAll"
            >
              <div style="padding: 0 0 30px 0">
                <el-button v-if="defaultValue.status !== 0 && activeName !== '' && detailTypeCheck !== 'goods'" type="primary" class="is-round is-fullwidth" @click="openAddOrder">
                  + 新增子訂單</el-button
                >
              </div>
            </TotalStatementDetail>
          </div>
        </div>
      </div>

      <!-- 點選完成預約，立即付款後的視窗 -->
      <div v-if="completeReserveAndPayStatus" class="orderformSection__info">
        <div class="orderformSection__info__header">
          <button class="el-drawer__close-btn" aria-label="close drawer" type="button" @click.stop="completeReserveAndPayStatus = false"><i class="el-dialog__close el-icon el-icon-close"></i></button>
          <h4 class="orderformSection__info__title">
            <div class="inline-between" style="padding-right: 15px; align-items: center">
              <span> 預約資訊 </span>
            </div>
          </h4>
        </div>
        <div class="orderformSection__info__content">
          <ReservePersonInfo ref="reserveForm" :member-info="memberInfo" @updatePayPersonInfo="updatePayPersonInfo" />
        </div>
      </div>

      <!-- 底部按鈕 -->
      <div class="orderformSection__bottom">
        <div style="display: flex; align-items: center; flex-shrink: 0;" class="orderformSection__bottom__left">
          <template v-if="defaultValue.paymentStatus">
            <BaseStateLabel :state="defaultValue.paymentStatus | paymentStatusMapFilter('color')" class="is-border d-md-inline d-none"
              >{{ defaultValue.paymentStatus | paymentStatusMapFilter('text') }}
            </BaseStateLabel>
          </template>
          <div class="Jost fw-medium text-secondary pl-md-4 ml-0">
            NT $ {{ paidAndUnPaidSummary.paid }}
            <span v-if="paidAndUnPaidSummary.unPaid !== 0" class="Jost" style="color:#e35d5d;margin-left:5px;font-size:12px;display:inline-block">
              ( {{ containerOrders.paymentMethod === 'Installment' ? getInstallmentUnpayCount : '' }}未付款金額 NT$
              {{ paidAndUnPaidSummary.unPaid }}
              )</span
            >
            <br />
            <BaseStateLabel v-if="containerOrders.paymentMethod === 'Installment'" class="text-muted-0" style="padding-top: 5px" state="info" text
              >{{ containerOrders.installments.length }}期付款</BaseStateLabel
            >
            <BaseStateLabel v-else class="text-muted-0" style="padding-top: 5px" state="info" text>{{ defaultValue.paymentMethod | orderPaymentMethodFilter }}</BaseStateLabel>
          </div>
        </div>

        <div style="padding:0 10px; margin-left: auto; flex-shrink: 0;">
          <el-button v-if="computedParentContainerIsTemp" class="no-color-text-btn is-circle is-border" style="font-size: 20px; margin-right: 5px" @click="writeDialogVisible = true">
            <BaseIcon name="envelope" :icon-style="'fal'"></BaseIcon>
          </el-button>
          <el-button
            v-if="computedParentContainerIsTemp && defaultValue.status !== 5 && defaultValue.status !== 0"
            style="font-size: 20px"
            class="is-boeder icon-text no-color-text-btn is-circle"
            @click="showShareDialog"
          >
            <BaseIcon name="paper-plane" :icon-style="'fal'"></BaseIcon>
          </el-button>

          <!-- 撰寫通知 -->
          <BaseButtonDialog :only-dialog="true" :title="'撰寫通知'" :dialog-visible.sync="writeDialogVisible" :destroy="true" floating>
            <NotificationWrite :selected-order-ids="[defaultValue.id]" source-name="order" :source-order="defaultValue" :map-template-string="messageData" @close="closeNotificationDialog" />
          </BaseButtonDialog>
          <!-- 分享連結 -->
          <el-dialog title="選擇發送方式" :visible.sync="shareDialogVisible" top="0" width="680px" append-to-body lock-scroll @open="tryToGetShareLink">
            <ul class="p-3 mb-3" style="border-radius: 8px; background:color-line">
              <li class="text-primary mb-3">{{ `#${defaultValue.id}` }}</li>
              <li class="mb-3">使用人：{{ defaultValue.fullName }} {{ defaultValue.gender | genderFilter }}</li>
              <li>訂購內容：{{ defaultValue.productName }} {{ defaultValue.date | formatDate }} {{ defaultValue.time }}</li>
            </ul>
            <div :class="$style['share__buttons']">
              <div :class="$style['share__button']">
                <el-button type="text" class="isPrimary" :class="$style['share__button']" @click="handleShareLink('facebook')">
                  <i class="fab fa-facebook-square" :class="$style['share__icon']"></i>
                </el-button>
                <div :class="$style['share__label']">Facebook</div>
              </div>
              <div :class="$style['share__button']">
                <el-button type="text" class="isPrimary" :class="$style['share__button']" @click="handleShareLink('line')">
                  <BaseIcon :class="$style['share__icon']" name="line" icon-style="fab" />
                </el-button>
                <div :class="$style['share__label']">Line</div>
              </div>
              <div :class="$style['share__button']" :loading="tryingSendSMS">
                <el-button type="text" class="isPrimary" :class="$style['share__button']" @click="tryToSendSMS">
                  <i class="fas fa-sms" :class="$style['share__icon']"></i>
                </el-button>
                <div :class="$style['share__label']">簡訊</div>
              </div>
              <div :class="$style['share__button']">
                <el-button type="text" class="isPrimary" :class="$style['share__button']" @click="copyShareLink">
                  <i class="fas fa-copy" :class="$style['share__icon']"></i>
                </el-button>
                <div :class="$style['share__label']">複製連結</div>
              </div>
            </div>
          </el-dialog>
        </div>
        <div v-if="!isEmployee" class="orderformSection__bottom__right">
          <!-- <el-button
            v-if="
              false &&
                defaultValue.status !== 0 &&
                defaultValue.paymentStatus === 'UNPAID' &&
                defaultValue.paymentMethod !== 'Credit' &&
                defaultValue.paymentMethod !== 'Vacc' &&
                defaultValue.paymentMethod !== 'Prepaid'
            "
            class="is-round orderformSection__bottom__btn-item"
            type="success"
            :loading="tryingPayOrder"
            @click="openPaidDialog"
            >付款</el-button
          > -->

          <template v-if="!completeReserveAndPayStatus">
            <el-button
              v-if="!thisParentContainerHasPaid"
              :disabled="testPrepaidOrderNotCheck"
              class="is-round orderformSection__bottom__btn-item"
              :type="getBottomBtnType"
              :loading="tryingPayOrder"
              @click="handlePayButton"
              >{{ containerIsTempToPay }}</el-button
            >

            <template v-else-if="defaultValue.allUnpaidTotal">
              <el-button v-if="!thisChildContainerHasPaid" class="is-round orderformSection__bottom__btn-checkChild" type="success" :loading="tryingPayOrder" @click="completeReserveAndPay">{{
                thisChildContainerIsTemp.text
              }}</el-button>

              <el-button v-else :disabled="testPrepaidOrderNotCheck" class="is-round orderformSection__bottom__btn-item" :type="getBottomBtnType" :loading="tryingPayOrder" @click="handlePayButton">{{
                containerIsTempToPay
              }}</el-button>
            </template>
          </template>

          <template v-if="completeReserveAndPayStatus">
            <el-button class="is-round orderformSection__bottom__completeBtn" @click="completeReserveAndPayStatus = false">取消填寫，返回</el-button>
            <el-button class="is-round orderformSection__bottom__completeBtn" type="primary" @click="checkResultAndPay">確認填寫，{{ directPayText }}</el-button>
          </template>

          <template v-if="testPrepaidOrderNotCheck">
            <el-button class="is-round orderformSection__bottom__btn-item" type="primary" :loading="tryingPayOrder" @click="goPayPrepaid">前往付款{{ $t('prepaid.BASE') }}訂單</el-button>
          </template>

          <template v-if="defaultValue.status === 4 && !thisChildContainerIsTemp.status">
            <el-alert v-if="!isPaid || unPaidAddOrder" class="orderformSection__bottom__right__alert" type="error" :closable="false">
              <span slot="title">請將訂單及子訂單款項結清，<br />始可完成簽名請款</span>
            </el-alert>
          </template>
        </div>
      </div>

      <!-- 報到與未報到 -->
      <el-dialog :visible.sync="checkinStatusDialogVisible" width="40%" top="0" custom-class="small-dialog" :close-on-click-modal="false" append-to-body>
        <div slot="title">
          <div class="circle-icon bg-success">
            <BaseIcon name="check"></BaseIcon>
          </div>
          <h4 style="margin-bottom: 10px">報到狀態</h4>
        </div>
        <el-button type="primary" class="is-round is-fullwidth" @click="onClickCheckIn"> 已報到 </el-button>
        <el-button type="primary" class="is-round is-fullwidth" @click="noShowDialogVisible = true"> 未報到 </el-button>
      </el-dialog>

      <!-- 確認將此訂單改為「已報到」 -->
      <el-dialog :visible.sync="checkinStatusDialogVisibleV2" width="550px" top="0" :close-on-click-modal="false" append-to-body :class="$style.checkInV2DialogTable">
        <div slot="title">
          <h4 style="margin-bottom: 10px">確認將此訂單改為「已報到」</h4>
        </div>
        <el-button type="primary" class="is-round is-fullwidth" @click="checkinStatusDialogV2Close"> 確認 </el-button>
        <el-button class="is-round is-fullwidth" @click="checkinStatusDialogVisibleV2 = true"> 取消 </el-button>
      </el-dialog>

      <!-- 報到 -->

      <el-dialog
        v-if="defaultValue.scheduleItem"
        :title="checkDialogSupplementMode ? '檢視服務條款 / 簽名' : '確認將此訂單改為「已報到」'"
        width="750px"
        :visible.sync="checkDialogVisible"
        top="0"
        append-to-body
        @close="onSalonContractDialogClose"
      >
        <el-form ref="beauticianForm" :rules="helpSubmitRules" class="p-3 pb-2" label-width="100px" label-position="left" style="background: color-line">
          <el-form-item label="美容師" class="mb-2">
            {{ defaultValue.scheduleItem ? defaultValue.scheduleItem.name : '' }}
          </el-form-item>
          <div element-loading-background="rgba(0, 0, 0,0)">
            <div v-for="item in checkedItem" :key="item.orderId">
              <el-form-item label="助理" class="mb-2">
                <HelperForShow item-show-key="editAssistantEnabled" only-for-show-text="目前無人員可指派" :item="item" show-key="helpers" />
              </el-form-item>
              <el-form-item v-if="$hasSpaceModule()" label="空間" class="mb-2">
                <HelperForShow item-show-key="editSpaceEnabled" only-for-show-text="目前無人員可指派" :item="item" show-key="spaceHelpers" />
              </el-form-item>
            </div>
          </div>
          <el-form-item label="美容契約" class="mb-2"> </el-form-item>
          <Terms :terms="terms" :agree.sync="salonTermsAgree" :readonly="checkDialogSupplementMode" class="mb-4" />
          <SignPad
            :signature-path="defaultValue.service_contract_signature"
            :supplement-mode="checkDialogSupplementMode"
            @signatureSaved="onSalonSignatureSaved"
          />
        </el-form>

        <div style="margin-top: 20px">
          <el-button
            v-if="!checkDialogSupplementMode"
            class="is-round w-100"
            :disabled="!salonTermsAgree"
            type="primary"
            :loading="tryingCheckIn"
            @click="tryToStoreAssignAndCheckIn"
          >確認</el-button>
          <el-button class="is-round w-100 mt-3 ml-0" type="primary" @click="onClickPrint">列印</el-button>
          <el-button class="is-round w-100 mt-3 ml-0" @click="checkDialogVisible = false">取消</el-button>
        </div>
      </el-dialog>

      <!-- 未報到 -->
      <el-dialog title="請說明未報到情況" width="550px" :visible.sync="noShowDialogVisible" top="0" append-to-body>
        <el-form ref="form" :model="submitData" :rules="{ note: [{ required: true, message: '請輸入情況！', trigger: 'blur' }] }">
          <el-form-item prop="note">
            <el-input v-model="submitData.note" type="textarea" class="is-round is-light is-border" :rows="4" placeholder="請輸入備註"></el-input>
          </el-form-item>
        </el-form>
        <el-row :gutter="20" style="margin-top: 20px">
          <el-col :span="24">
            <el-button :loading="tryingNoShow" :disabled="tryingNoShow" type="danger" class="is-round is-fullwidth" @click="onClickNoShow">未報到</el-button>
          </el-col>
          <el-col :span="24">
            <el-button class="is-round is-fullwidth mt-3" @click="noShowDialogVisible = false">返回</el-button>
          </el-col>
        </el-row>
      </el-dialog>

      <!-- 退款視窗 -->
      <el-dialog v-if="orderRefundShow" title="退款" width="550px" :visible.sync="orderRefundShow" top="0" append-to-body destroy-on-close>
        <RefundForm :show-all-status="showAllStatus" :current-order="currentOrder" :loading="tryingRefund" @submit="tryToRefund" @close="closeOpenRefund" />
      </el-dialog>
    </div>

    <!--列印美容契約  -->
    <PrintSalonContract ref="printer" :html-content="printHtml" />
    <!-- 變價或加購 -->
    <div v-if="totalAllShow" class="orderformSection__all">
      <div class="orderformSection__right" style="border-right: #dcdfe6 1px solid">
        <div class="orderformSection__right__header">
          <button class="el-drawer__close-btn" aria-label="close drawer" type="button" @click.stop="isChildrenOrderCreating ? closeChildren() : cancelToTalEdit()"
            ><i class="el-dialog__close el-icon el-icon-close"></i
          ></button>
          <h4 class="orderformSection__right__title">
            <div class="inline-between" style="padding-right: 15px; align-items: center">
              <span v-if="isChildrenOrderCreating"> 新增子訂單 </span>
              <span v-else> 價格編輯與折扣 </span>
            </div>
          </h4>
        </div>

        <div class="orderformSection__right__content" style="padding: 0 0 20px 0">
          <div v-if="selectSingleOrder" :class="'orderformSection__beforeTotalAllShowLeft__box'">
            <div v-if="activeName === ''">
              <div :class="'orderformSection__beforeTotalAllShowLeft__info'">
                <div>
                  <p>總訂單</p>
                </div>
                <el-button class="is-round" type="primary" @click="seeOrder({}, 'add')">為總訂單編輯加購</el-button>
              </div>
            </div>
            <template v-if="activeName !== ''">
              <div v-for="(item, index) in containerParentIdNullOrder" :key="index">
                <p>{{ item.date }} {{ item.time }}</p>
                <div :class="'orderformSection__beforeTotalAllShowLeft__info'">
                  <div v-if="orderType !== 'goods'">
                    <p>{{ item.pet.name }}</p
                    ><span>{{ item.pet.categoryTitle }}/{{ item.pet.sizeTitle }}</span>
                  </div>
                  <div v-if="orderType !== 'goods'">
                    <p>{{ item.params[0].title }}</p>
                  </div>
                  <div v-if="orderType === 'goods'">
                    <p>商品訂單</p>
                  </div>
                  <div v-if="orderType === 'goods'">
                    <p>{{ item.id }}</p>
                  </div>
                  <el-button class="is-round" type="primary" @click="seeOrder(item, 'add')">編輯加購</el-button>
                </div>
              </div>
            </template>
          </div>
          <TotalStatement
            v-if="!selectSingleOrder"
            enabled-edit
            enabled-addition
            is-order-created
            :is-employee="isEmployee"
            :is-children-order-creating="isChildrenOrderCreating"
            :order-type="detailTypeCheck"
            :member-info="memberInfo"
            :default-value="isChildrenOrderCreating ? childrenSubmitData : currentOrder"
            :default-coupon="couponInfo"
            :container-edit="containerEdit"
            @openAdd="openAddEdit"
            @openTotalEdit="openTotalEdit"
            @update="onUpdateTotalStatement"
          >
            <div :class="$style.bottom" style="padding: 0 0 26px;">
              <template v-if="isChildrenOrderCreating">
                <div class="children__bottom">
                  <el-button
                    style="margin-top: 20px; width: 100%"
                    class="is-round orderformSection__bottom__btn"
                    type="primary"
                    :disabled="tryingStore || childrenSubmitData.params.length === 0"
                    :loading="tryingStore"
                    @click="onlyCreateChildrenOrder"
                  >
                    新增子訂單
                  </el-button>
                </div>
              </template>
              <template v-else>
                <el-form v-if="isCouponEditable" ref="couponForm" :model="submitData" :rules="submitRules">
                  <el-form-item ref="couponCode" class="el-form-item--white-bg" prop="couponCode">
                    <el-input v-model="submitData.couponCode" clearable :disabled="!!hasCouponInfo" placeholder="請輸入優惠券代碼" class="isStyleButton">
                      <el-button v-if="hasCouponInfo" slot="append" class="is-round is-border" @click="resetCoupon">清除優惠券</el-button>
                      <el-button v-else slot="append" type="primary" class="is-round" :loading="tryingValidCouponCode" @click="validCoupon">使用優惠券</el-button>
                    </el-input>
                  </el-form-item>
                </el-form>
                <div class="btn-group-inline">
                  <el-button class="is-round" type="primary" :loading="tryingStoreOrderItem" @click="tryToStoreOrderItem">確認修改</el-button>
                </div>
              </template>
            </div>
          </TotalStatement>
        </div>
      </div>
      <!-- 點選加購之後，先跳出要選哪個訂單 -->
      <div v-if="selectSingleOrder" class="orderformSection__mask">
        <div>
          <p>尚未選擇需要加購的預約</p>
        </div>
        <div> </div>
      </div>
      <div class="orderformSection__left" style="border: 0">
        <div class="orderformSection__left__content" style="padding-bottom: 0">
          <template v-if="visibleAdditionForm">
            <div class="orderformSection__right__header">
              <button class="el-drawer__close-btn" aria-label="close drawer" type="button" @click.stop="closeAdd"><i class="el-dialog__close el-icon el-icon-close"></i></button>
              <h4 class="orderformSection__right__title">
                <div class="inline-between" style="padding-right: 15px; align-items: center"> 加購 </div>
              </h4>
            </div>
            <div class="info-section">
              <AdditionFormOrder
                ref="addForm"
                :this-time-selected-pet-info="thisTimeSelectedPetInfo"
                :is-edit-mode="true"
                :set-services-member-level-price="setServicesMemberLevelPrice"
                :member-info="memberInfo"
                :pet-size-id="petSizeId"
                :pet-category-id="petCategoryId"
                :default-value.sync="defaultValue"
                @submit="onSubmitAddition"
                @close="closeAdd"
              />
            </div>
          </template>
          <TotalEdit v-else @submit="onSubmitTotalEdit" :address-edit-check="orderType === 'goods'"></TotalEdit>
        </div>
      </div>
    </div>

    <!-- 簽名請款 -->
    <SignatureDialog
      :key="signDialogKey"
      :member-info="memberInfo"
      :one-step="true"
      :start-tab="startTab"
      :props-store-invoice-setting="storeInvoiceSetting"
      :visible.sync="signDialogVisible"
      :order="{ ...defaultValue }"
      @update="signatureUpdate"
      @closeSignature="signDialogVisible = false"
      @closeSignaturDialog="closeSignaturDialog"
    />

    <!-- 選擇付款方式和訂單狀態 -->
    <PaymentFormDialog :visible.sync="paymentDialogVisible" :payment-way="paymentWay" :loading="tryingStore" :price-total="submitPriceTotal" @submit="onSubmitPaymentForm" />

    <!-- 取消訂單/刪除訂單視窗 -->
    <OrderChangeStatusDialog
      :visible.sync="statusDialogVisible"
      :order="{ ...currentOrder, status: 0 }"
      :container-all-item="containerAllItem"
      @cancelled="updateOrder"
      @emitStore="emitStore"
      @deleteLocalStorage="deleteLocalStorage"
      @renewContainerOrders="renewContainerOrders"
    />

    <!-- 付款方式列表 -->
    <div v-if="checkResultAndPayStatus" :class="$style.payListF">
      <PayList
        :pay-person-info="payPersonInfo"
        :submit-price-total="submitPriceTotal"
        :have-new-order="haveNewOrder"
        :member-info="memberInfo"
        :order-container-uuid="orderContainerUuid"
        :store-invoice-setting="storeInvoiceSetting"
        :child-order-container-id="testUnpaidContainer"
        :container-orders="containerOrders"
        :order-paying="orderPaying"
        @showSignDialogFromPayList="showSignDialogFromPayList"
        @goBack="backToInfo"
        @checkOutSuccess="checkOutSuccess"
        @storeSingleOrder="storeSingleOrder"
        @paymentMethodDeposit="paymentMethodDeposit"
      />
    </div>

    <!-- 新增儲值金訂單 -->
    <el-drawer
      ref="depositOrderForm"
      class="only-close"
      :class="{ appStyle: appStyle }"
      :visible.sync="createDepositOrderVisible"
      :append-to-body="true"
      :size="$root.isSmallDevice ? '100%' : '90%'"
      destroy-on-close
      :modal-append-to-body="false"
      :wrapper-closable="false"
      custom-class="order-drawer"
    >
      <DepositOrderForm :order-member-id="memberInfo.id" order-type="deposit" @store="onCreateDepositOrderDone" />
    </el-drawer>
  </div>
</template>
<style lang="scss" module>

.serviceCollapse {
  background-color: white;
  margin-bottom: 10px;

  &:not(:first-child) {
    border-top: 1px solid $color-border-base;
    padding-top: 15px;
  }

  &__title {
    > p {
      flex-grow: 1;
      text-align: right;

      > span {
        margin-right: 10px;
      }

      &:hover {
        cursor: pointer;
      }
    }
  }

  &__context {
    display: flex;
    flex-direction: column;

    &__info {
      display: flex;
      justify-content: space-between;
      align-items: center;

      &__label {
        height: 32px;
      }
    }
  }

  &__detail {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  &__btnGroup {
    align-self: flex-end;
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    &__Sign {
      margin-bottom: 10px;
    }

    &__checkInStatus {
      display: inline-block !important;
      // height: 44px !important;
      // width: 112.41px !important;
      // font-size: 14px !important;
      // line-height: 33px !important;
      margin-left: 0 !important;
      text-align: center;
    }

    &__btn {
      height: 44px !important;
      width: 112.41px !important;
      margin-left: 0 !important;
    }
  }

  &__member {
    display: flex;
    flex-direction: column;
    align-items: space-around;
  }
}

.orderformSection {
  :global {
    .form-block-title {
      font-size: 16px;
      padding-bottom: 0;
      margin-top: 0;
    }

    .info-section {
      padding: 30px 40px;

      @include max-lg {
        padding: 15px 20px;
      }
    }

    .orderformSection {
      &__all {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        height: 100%;
        position: relative;
        // display: none;
      }

      &__left {
        width: 57%;
        border-right: $color-border-base 1px solid;
        display: flex;
        flex-direction: column;
        justify-content: stretch;
        background: $color-line;

        &__content {
          height: 100vh;
          overflow: auto;
          padding-bottom: 90px;

          &__bg {
            background-color: white;
            padding: 18px;
            margin-bottom: 10px;
          }

          &__tab {
            p {
              font-size: 20px;
            }

            :global {
              .el-tabs__header {
                margin: 0;
              }

              .el-tabs__nav-scroll {
                background-color: white;
                height: 92px;

                :global {
                  .el-tabs__item {
                    height: 90px;
                    width: 110px;
                    padding: 0;
                    background-color: #f2f2f2;
                    color: #121931;
                    opacity: 0.5;

                    &.is-active {
                      background-color: white !important;
                      border-left: 1px solid #f2f2f2;
                      border-right: 1px solid #f2f2f2;
                      border-top: 2px solid $color-primary;
                      border-bottom: 1px solid #f2f2f2;
                      color: $color-primary;
                      opacity: 1;
                    }
                  }
                }
              }

              .tabHeader {
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                padding-top: 15px;
              }

              .el-tabs__nav-wrap {
                display: flex;
                align-items: center;

                > span {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  background-color: white;
                  height: 100%;
                  width: 44px;

                  > i {
                    color: black;
                  }
                }
              }
            }
          }

          &__tabMorePadding {
            :global {
              .el-tabs__nav-wrap {
                padding-left: 44px;
                padding-right: 44px;
              }
            }
          }

          &__timeMain {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 142px;
            height: 35px;
            background-color: #f8e0e2;
            color: red;
            border-radius: $border-radius;
          }

          &__time {
            display: flex;
            justify-content: flex-end;
          }
        }
      }

      &__right {
        position: relative;
        width: 43%;
        height: calc(100vh);
        overflow: hidden;
        background: $color-line;

        .orderformSection__right__header {
          background-color: $color-line;
          z-index: 999;
        }

        &__title {
          margin: 0;
          padding: 19px 0;
          padding-left: 50px;
        }

        &__header {
          position: relative;
          border-bottom: $color-border-base 1px solid;

          .el-drawer__close-btn {
            // font-weight: 300;
            color: #72767b;
            position: absolute;
            padding: 15px;
            border: 0;
            left: 0;
            top: 3px;
          }

          .el-tabs__item {
            height: auto;
            padding: 10px 0;
          }

          .el-tabs__nav-wrap::after {
            display: none;
          }

          .el-tabs__header {
            margin-bottom: 0;
          }

          .el-tabs--top {
            margin-left: 60px;

            @include max-lg {
              margin-left: 30px;
            }
          }
        }

        &__content {
          z-index: 10;
          height: calc(100vh - 60px);
          overflow: auto;
          padding: 30px;
          padding-bottom: 120px;
          position: relative;
          background-color: $color-line;

          @include max-lg {
            padding: 20px;
          }
        }
      }

      &__bottom {
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 30px;
        background: #fff;
        box-shadow: 0 -5px 5px rgba(#eee, 0.3);
        z-index: 999;

        @include touch {
          // position: static;
          position: sticky;
          flex-wrap: wrap;
          padding: 15px;
          justify-content: flex-start;
        }

        &__left {
          @include touch {
            width: 100%;
          }
        }

        &__btn {
          width: 40%;
        }

        &__btn-item {
          // min-width: 132px;
          width: 192px;
          max-width: 100%;

          @include max-lg {
            width: 100%;
          }
        }

        &__btn-checkChild {
          width: 250px;
          max-width: 100%;

          @include max-lg {
            width: 100%;
          }
        }

        &__right {
          display: flex;
          align-items: center;
          margin-left: 1rem;

          &__alert {
            display: inline-block;
            width: auto;
            margin-left: 20px;
            flex-shrink: 0;

            @include touch {
              width: 100%;
              margin-left: 0;
              margin-top: 1rem;
            }
          }

          @include touch {
            display: block;
            width: 100%;
            margin-left: 0;
            order: -1;
            margin-bottom: 10px;
          }
        }
      }

      &__checkInBtn {
        max-width: 100% !important;
        width: 175px !important;

        @include max-lg {
          width: 90px !important;
        }
      }

      &__info {
        position: relative;
        width: 100%;
        height: calc(100vh);
        overflow: hidden;
        background: $color-line;

        .orderformSection__info__header {
          background-color: $color-line;
          z-index: 999;
        }

        &__title {
          margin: 0;
          padding: 19px 0;
          padding-left: 50px;
        }

        &__header {
          position: relative;
          border-bottom: $color-border-base 1px solid;

          .el-drawer__close-btn {
            // font-weight: 300;
            color: #72767b;
            position: absolute;
            padding: 15px;
            border: 0;
            left: 0;
            top: 3px;
          }

          .el-tabs__item {
            height: auto;
            padding: 10px 0;
          }

          .el-tabs__nav-wrap::after {
            display: none;
          }

          .el-tabs__header {
            margin-bottom: 0;
          }

          .el-tabs--top {
            margin-left: 60px;
          }
        }
      }

      &__beforeTotalAllShowLeft {
        color: blue;

        &__box {
          display: flex;
          flex-direction: column;
          width: 100%;
          height: 100%;
          padding: 20px;
          overflow-y: auto;

          > div > p {
            font-size: 16px;
            color: $color-secondary;
          }
        }

        &__moreMargin {
          margin-bottom: 50px;
        }

        &__info {
          display: flex;
          flex-direction: column;
          padding: 16px 18px;
          width: 100%;
          background-color: white;
          border-radius: $border-radius;
          border: 1px solid $color-border-base;

          > div {
            display: flex;
          }

          > div:nth-child(1) {
            margin-bottom: 6px;
          }

          > div:nth-child(2) {
            margin-bottom: 10px;
          }

          p {
            color: $color-secondary;
            margin: 0;
            margin-right: 8px;
            letter-spacing: 1.92px;
          }

          span {
            color: $color-text-light;
          }

          :global {
            .el-button {
              span {
                color: white;
              }
            }
          }
        }
      }

      &__mask {
        position: absolute;
        z-index: 100000;
        right: 0;
        width: 57%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        > div:nth-child(1) {
          color: white;
          position: absolute;
          z-index: 2;
          font-size: 20px;
        }

        > div:nth-child(2) {
          background: rgba(0, 0, 0, 0.4);
          width: 100%;
          height: 100%;
          right: 0;
          z-index: 1;
          backdrop-filter: blur(5px);
          position: absolute;
        }
      }
    }

    .info-icon {
      color: #fff;
      background-color: $color-primary;
      display: inline-block;
      margin-right: 1rem;
      padding: 7px 10px;
      font-weight: 300;
      font-size: 12px;
      flex-shrink: 0;

      &.isPrepaid {
        background-color: #2d385f;
      }
    }
  }
}

.header {
  margin-top: 5px;
  // margin-bottom: 30px;
  padding-right: 40px;
  padding-left: 60px;
  padding-bottom: 10px;
  border-bottom: $color-border-base 1px solid;

  @include max-lg {
    padding-right: 20px;
  }

  :global {
    h5 {
      font-size: 18px;
    }

    .header {
      &__right {
        margin-left: auto;
        align-self: end;
        margin-bottom: 1rem;

        @include max-md {
          margin-bottom: 0;
        }
      }
    }
  }
}

.payListF {
  :global {
    .el-drawer__close-btn {
      display: none !important;
    }
  }
}

.infoList {
  // margin-bottom: 30px;
  padding-top: 5px;

  // border-bottom: 1px solid $color-border-base;
  // font-size: 16px;
  :global {
    .muted {
      color: $color-text-secondary;
    }

    .el-tag + .el-tag {
      margin-left: 10px;
    }

    .infoList {
      &__title {
        font-weight: 500;
        margin-bottom: 20px;
      }

      &__item {
        margin-bottom: 15px;
      }

      &__row {
        margin-bottom: 20px;
      }
    }
  }
}

.detail li {
  line-height: 40px;
}

// 地址
.footer {
  display: flex;

  :global {
    button {
      flex: 1 0 auto;
    }
  }
}

// 服務
.price {
  display: flex;
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: $color-border-base 1px solid;

  &:global {
    &:hover {
      .price__title {
        color: $color-primary;
        transition: all 0.35s;
      }
    }

    &.isActive {
      .price__title {
        color: $color-primary;
        // transition: all 0.35s;
      }
    }

    &.isDisabled {
      pointer-events: none;
    }
  }

  :global {
    .price {
      &__image {
        width: 50%;
        height: 10vw;
        border: 0;

        @include max-md {
          height: auto;
        }
      }

      &__cont {
        width: 50%;
        padding-left: 15px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }

      &__title {
        font-weight: 500;
        margin-bottom: 10px;
        padding-top: 10px;
      }
    }

    .text-muted-0 {
      font-size: 14px;
    }
  }
}

.prepaid {
  :global {
    .prepaid {
      &__image {
        width: 100%;
        height: 20vw;
        border: 0;
        margin-bottom: 10px;
      }

      &__title {
        font-weight: 500;
      }
    }
  }
}

// 變價
:global {
  .children__bottom {
    padding: 30px 30px 0;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    border-top: $color-border-base 1px solid;

    h6 {
      margin-top: 0;
    }

    :global {
      .el-radio-group {
        display: flex;
      }

      .el-radio {
        margin-right: 0;
        padding-right: 12px;
        border-radius: 7px;
        margin-left: 0;
        width: 100%;
        background-color: #fff;
      }
    }
  }

  .payment-radio {
    // padding: 30px 30px 0;
    // position: absolute;
    // left: 0;
    // bottom: 0;
    width: 100%;

    // border-top: $color-border-base 1px solid;
    h6 {
      margin-top: 0;
    }

    :global {
      .el-radio-group {
        display: flex;
        flex-wrap: wrap;
        margin-right: -15px;
      }

      .el-radio {
        margin-right: 15px;
        // padding-right: 12px;
        border-radius: 7px;
        margin-left: 0 !important;
        width: calc(50% - 15px);
        background-color: #fff;
        margin-bottom: 15px;
      }
    }
  }
}

.total {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  height: 100%;
  z-index: 1;

  @include touch {
    position: static;
  }

  :global {
    .total {
      &__cont {
        // padding: 30px 30px;
        height: calc(100% - 80px);

        @include touch {
          height: auto;
        }
      }

      &__bottom {
        padding: 30px 30px;
        position: absolute;
        bottom: 80px;
        width: 100%;
        border-top: $color-border-base 1px solid;

        h6 {
          margin-top: 0;
        }

        :global {
          .el-radio-group {
            display: flex;
          }

          .el-radio {
            margin-right: 0;
            padding-right: 12px;
            border-radius: 7px;
            margin-left: 0;
            width: 100%;
            background-color: #fff;
          }
        }
      }
    }
  }
}

.bottom {
  /* position: absolute;
  bottom: 0; */
  width: 100%;
  padding: 0 30px 0;

  @include touch {
    position: static;
  }
}

.editOneLineAssistant {
  min-height: 60px;
  height: auto;
  overflow: visible;
  flex-wrap: nowrap;

  :global {
    .helper-select-multiple {
      flex-shrink: 1;
      min-width: 0;
    }

    .el-button {
      flex-shrink: 0;
    }
  }
}

.editOneLine {
  display: flex;
  align-items: center;
  position: relative;
  flex-wrap: wrap;

  :global {
    .el-form-item__error {
      position: static;
      width: 100%;
      padding-left: 80px;
    }

    .editOneLine {
      &__title {
        margin: 0 12px 0 0;
        font-size: 14px;
        color: #6c6c6b;
        display: inline-flex;
        align-items: center;
        gap: 4px;
      }

      &__text {
        font-size: 14px;
        margin-right: 15px;
      }
    }

    .el-form-item {
      margin-bottom: 0;
      margin-right: 15px;

      &.isFull {
        margin-bottom: 20px;
      }
    }

    .el-input__inner {
      background-color: #fff;
      height: 40px;
    }
  }
}

.titleBox {
  padding: 20px;
  background: #fff;
}

.box {
  display: flex;
  flex-wrap: wrap;
  // padding: 20px 20px 10px;
  // background: #fff;
  margin-bottom: 20px;

  :global {
    li {
      //  width: 50%;
      margin-bottom: 15px;
      margin-right: 30px;
    }

    .row-line {
      width: 100%;
    }
  }
}

.info {
  padding-inline-start: 0;

  > li {
    display: inline-block;
    color: #909399;
    padding: 5px 0;
    margin-right: 15px;
  }
}

.share {
  &__buttons {
    display: flex;
    align-items: center;
    text-align: center;
  }

  &__button {
    flex: 1;
  }

  &__icon {
    font-size: 3rem;
  }

  &__label {
    margin-top: 10px;
  }
}

.invoice {
  :global {
    .order-id {
      font-size: 16px;
      letter-spacing: 1.6px;
      line-height: 18px;
      margin-bottom: 20px;
      font-weight: 500;
    }

    .info {
      padding: 22.5px 20px;
      background: white;

      @include touch {
        border: 1px solid #c6c6ba;
      }

      .el-col {
        padding-top: 7.5px;
        padding-bottom: 7.5px;
      }

      .info-item {
        .title {
          width: 60px;
          display: inline-block;
          color: #919191;
          margin-right: 20px;
        }

        & + .info-item {
          margin-top: 15px;
        }
      }
    }
  }

  & + .invoice {
    margin-top: 40px;
  }
}

.checkInV2DialogTable {
  :global {
    .el-table__header-wrapper {
      display: none;
    }

    .el-table {
      margin-bottom: 30px;
    }

    .el-table__row {
      & > td {
        background-color: $color-line;
        height: 20px;
        padding-left: 20px;
      }
    }
  }
}

.ovetTimeDialog {
  &__mainTimeDetail {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 20px 24px;
    border: 1px solid $color-line-dark;
    border-radius: $border-radius;

    & > div {
      width: 50%;
    }
  }

  &__contextDetail {
    display: flex;
    height: auto;
    flex-direction: column;
    justify-content: space-between;

    & > p {
      color: $color-secondary;
      font-size: 16px;
    }

    & > div {
      display: flex;
      flex-direction: column;
      justify-content: center;
      flex-grow: 1;

      p {
        margin-top: 4px;
        margin-bottom: 4px;
        color: $color-state-service;
      }
    }
  }

  &__time {
    color: $color-primary !important;
    font-size: 20px;

    span {
      color: red;
      font-size: 12px;
    }
  }

  &__centerText {
    padding: 10px 14px;
    background-color: $color-input-bg;
    border-radius: $border-radius;
  }
}

.specifyClass {
  margin-top: 13px;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  :global {
    .specifyRadio {
      margin-left: 5px;
    }

    .editOneLine {
      &__title {
        margin: 0;
        font-size: 14px;
        color: #6c6c6b;
      }

      &__text {
        font-size: 14px;
        margin-right: 15px;
      }
    }
  }
}

.signaturePreview {
  width: 100%;
  height: 180px;
  object-fit: contain;
  border: solid 2px #e5e7eb;
  border-radius: 8px;
  display: block;
}

.signaturePlaceholder {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  color: #999;
}

.serviceContractSection {
  margin-bottom: 8px;

  .signaturePreview {
    height: 120px;
  }

  .signaturePlaceholder {
    font-size: 16px;
  }

  :global {
    [class*='BaseCollapse_BaseCollapse'] {
      margin-bottom: 0;
    }

    [class*='BaseCollapse_header'] {
      padding: 8px 12px;
    }

    [class*='BaseCollapse_content'] {
      padding: 8px 12px 0;
    }
  }
}

.serviceContractBtn {
  width: 100%;
  margin-top: 12px;
  margin-left: 0 !important;
}
</style>
